import {
  Box,
  Grid,
  styled,
  Typography,
  Checkbox,
  ListItem,
  List,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent
} from "@mui/material";
import React, { useEffect, useState,useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import candidateActions from "../../redux/candidate/actions";
import MarksTable from "../../common/marksTable";
import GovernmentImage from "../../assets/images/Government.png";
import CetImage from "../../assets/images/Cet.png";
import Ara from "../../assets/images/Ara.jpeg";
import { MdOutlineModeEdit } from "react-icons/md";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import PrintDownloadButton from "../../common/button/printDownloadButton";
import { useReactToPrint } from "react-to-print";
import { MdPrint } from "react-icons/md";
import masterFormsActions from "../../redux/masterForms/actions";


export default function PrintApplicationForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
   const [ipaddress, setIpAddress] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState("");
  const [CheckboxValue, setCheckBoxValue] = useState(false);
    const [scribe1Details, setScribe1Details] = useState(null);
  const [scribe2Details, setScribe2Details] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);

  const { courseid } = location.state || {};

  const {gspecializationSubjectList, gspecialEdMethodSubjectList, stateList, pgBranchList, pgawardedClassList, educationStreamList, pgSpecialName, educationClassList} = useSelector((state) => state.masterFormsReducer);
  const fullCandidateDetails = useSelector((state) => state.candidateReducer.fullCandidateDetails);
  const fullCandidateScribeDetails = useSelector((state) => state.candidateReducer.fullCandidateScribeDetails);
    const uploadDetails = useSelector((state) => state.candidateReducer.uploadDetails );
    const scribe1PhotoDetails = useSelector((state) => state.candidateReducer.scribe1PhotoDetails)
  // const isPwdAllowed = ![7, 24]?.includes(parseInt(fullCandidateDetails[0]?.pwdsubtypeid))

  const photo = uploadDetails?.find(
  item => Number(item.documenttype) === 1
  );

  const signature = uploadDetails?.find(
  item => Number(item.documenttype) === 2
  );


  const targetRef = useRef();
 const handlePrint = useReactToPrint({
 contentRef: targetRef,
  documentTitle: "Print Application",
  removeAfterPrint: true,

    onBeforePrint: async () => {
    setIsPrinting(true);
  },

  onAfterPrint: () => {
    setIsPrinting(false);
  },
});
console.log(fullCandidateDetails?.[0],"oijuyhjkjinhb")
const candidateid=localStorage.getItem("candidateid");
  useEffect(() => {
    if (!isLoading && fullCandidateDetails && uploadDetails.length >= 3) {
      const hasPhoto = uploadDetails?.find(
        (detail) => detail.documenttype === 1
      );
      const hasSignature = uploadDetails?.find(
        (detail) => detail.documenttype === 2
      );
      const hasDocument = uploadDetails?.find(
        (detail) => detail.documenttype === 3
      );

      // if (hasPhoto && hasSignature && hasDocument) {
      //   // window.print();
      //   navigate("/mhcet/search-candidate", { replace: true });
      // }
    }
  }, [isLoading, fullCandidateDetails, uploadDetails, navigate]);


  useEffect(() => {
      dispatch({ type: masterFormsActions.GET_GSPECIALIZATION_SUBJECT })
      dispatch({ type: masterFormsActions.GET_PG_AWARDED_CLASS });
      dispatch({ type: masterFormsActions.GET_POST_GRADUATION_BRANCH });
      dispatch({ type: masterFormsActions.GET_STATE });
      dispatch({type: masterFormsActions.GET_GSPECIAL_ED_METHOD_SUBJECT})
      dispatch({ type: masterFormsActions.GET_EDUCATION_STREAM });
      dispatch({ type: masterFormsActions.GET_EDUCATION_CLASS})
  },[]);



  useEffect(() => {
    if (candidateid) {
      if (!fullCandidateDetails || !uploadDetails) {
        dispatch({
          type: candidateActions.GET_FULL_CANDIDATE_DETAILS,
          payload: { id: candidateid },
        });
        dispatch({
          type: candidateActions.GET_UPLOAD_PERSONAL_DETAILS,
          payload: { id: candidateid },
        });
      }
    }
  }, [candidateid, dispatch]);


    useEffect(() => {
    if (candidateid) {
        dispatch({
          type: candidateActions.GET_FULL_SCRIBE_CANDIDATE_DETAILS,
          payload: { id: candidateid },
        });
    }
  }, [candidateid]);


const { courseList,cetExamList } = useSelector((state) => state.masterReducer);
  useEffect(() => {
    if (fullCandidateDetails && uploadDetails.length >= 3) {
      setIsLoading(false);
    }
  }, [fullCandidateDetails, uploadDetails]);

  useEffect(() => {
    if (uploadDetails && uploadDetails.length >= 3) {
      const documentDetail = uploadDetails.find(
        (detail) => detail.documenttype === 3
      );

      if (documentDetail && documentDetail.document) {
        try {
          const base64Data =
            documentDetail.document.split(",")[1] || documentDetail.document;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
          return () => URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error decoding Base64 string:", error);
        }
      }
    }
  }, [uploadDetails]);
   const Language = [
    { value: 1, label: "English" },
    { value: 2, label: "Marathi" },
    { value: 3, label: "Urdu" },
    { value: 4, label: "Hindi" },
  ];
 const docTypes = [
    { value: 1, label: "A" },
    { value: 2, label: "B" },
    { value: 3, label: "C" },
  ];

  const docTypeNo = [
    { value: 0, label: "Not Applicable" },
    { value: 1, label: "type 1" },
    { value: 2, label: "type 2" },
  ];

  const YesOrNo = [
    { value: 0, label: "Not Applicable" },
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];
  const handleCheckbox = (e) => {
    const checked = e.target.checked;
    setCheckBoxValue(checked);
    setError("");
  };

  const style = styled({
    fontStyle: {
      fontWeight: 600,
    },
  });
  const classes = style();

  const status = fullCandidateDetails?.status;
  const isPaid = fullCandidateDetails?.ispaid;
const fetchIpAddress = async () => {
    try {
      const response = await fetch('https://api.ipify.org/?format=json');
      const data = await response.json();
      setIpAddress(data?.ip);
    } catch (error) {
      console.error('Error fetching IP address:', error);
    }
  };

  useEffect(() => {
  
      fetchIpAddress()
    
  }, []);

    const fileUrl =
    uploadDetails?.find((item) => item?.documenttype === 1)?.fileurl;
  // console.log(courseUploadDetails,"courseupload details")
  const fileUrl2 =
    uploadDetails?.find((item) => item?.documenttype === 2)?.fileurl;


    useEffect(() => {
    if (!Array.isArray(fullCandidateScribeDetails)) {
      setScribe1Details(null);
      return;
    }

    const found = fullCandidateScribeDetails?.find(
      (item) =>
        item?.scribetype === 1
    );

    setScribe1Details(found || null);
  }, [fullCandidateScribeDetails]);

  // console.log(fullCandidateScribeDetails,"fullCandidateScribeDetailscojnsoleddddd")


  useEffect(() => {
    if (!Array.isArray(fullCandidateScribeDetails)) {
      setScribe2Details(null);
      return;
    }

    const found = fullCandidateScribeDetails?.find(
      (item) =>
        item?.scribetype === 2
    );

    setScribe2Details(found || null);
  }, [fullCandidateScribeDetails]);


    useEffect(() => {
    if (candidateid) {
      dispatch({
        type: candidateActions.GET_SCRIBE1_PHOTO_DETAILS,
        payload: {
          candidateid: candidateid,
          courseid: courseid || localStorage.getItem("courseid")
        }
      })
    }
  }, [candidateid])

    useEffect(() => {
    if (fullCandidateDetails?.[0]?.pgbranchid) {
      dispatch({
        type: masterFormsActions.GET_PG_SPECIALISATION_NAME,
        payload: { id: fullCandidateDetails?.[0]?.pgbranchid },
      })
    }
  }, [fullCandidateDetails])


  console.log(pgSpecialName,"pgspecialnamecosnoelddddd")
  // console.log(fullCandidateDetails?.[0]?.gspecialeducationmethod, "lkjhgfdswqertyuiop")

  const getDocumentName = (type) => {
    switch (type) {
      case 1:
        return "Candidate Photo";

      case 2:
        return "Candidate Signature";

      case 3:
        return "Proof of Identity";

      case 4:
        return "Candidate UDID / Disability Certificate";

      case 5:
        return "Appendix 1 & 2 certificate";

      default:
        return "Unknown Document";
    }
  };
  const [open, setOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const handleOpen = (doc) => {
    setSelectedDocument(doc);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedDocument(null);
  };

  const getFileExtension = (url = "") => {
    return url
      ?.split("?")[0]
      ?.split(".")
      ?.pop()
      ?.toLowerCase();
  };

  const isImageFile = (url) => {
    const ext = getFileExtension(url);

    return ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
  };

  const isPdfFile = (url) => {
    return getFileExtension(url) === "pdf";
  };

  return (
    <Box>
         
          <Box
            sx={{
              width:"98%",
              margin: "0 auto",
              minHeight: "50vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "2px 0px",
              // border: `1px solid ${cssProperties.bordercolor.secondary3}`,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                padding: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
               <PrintDownloadButton
      name="Print Application Form"
      handleSubmit={handlePrint}   // direct pass karo
      startIcon={<MdPrint />}
    />
                {/* <PrintDownloadButton
                  name="Download Receipt"
                  handleSubmit={() => toPDF()}
                  startIcon={<MdDownload />}
                /> */}
              </Box>
            </Box>
            <div
             id="receipt"
              ref={targetRef}
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
              }}
             
            >
    <Box
      //   p={3}
      style={{
        minHeight: "50vh",
        backgroundColor: "#fff",
        // borderRadius: "8px",
        border: "2px solid #000",
      }}
      // ref={targetRef}
    >
      <Box
        style={{
          borderBottom: "1px solid #000",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography fontWeight={600}
                sx={{
                  marginLeft: "5px", textAlign: "left", width: "100%", fontSize: 15
                }}>
          Online Registration For {fullCandidateDetails?.[0]?.coursename}
        </Typography>
        <Typography fontWeight={600} sx={{textWrap:"nowrap",fontSize:15,marginRight:"10px"}}>
          Application Form
        </Typography>
      </Box>
      <Grid
        container
        //   p={3}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "1px solid #000",
        }}
        pl={1}
      >
        <Grid item sx={{ width: "25%" }}>
          <img
            style={{ height: "70px", width: "auto" }}
            src={CetImage}
            alt="image"
          />
        </Grid>
        <Grid
          item
          // md={8}

          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            flex: 1,
          }}
        >
          <img
            style={{ height: "75px", width: "auto" }}
            src={GovernmentImage}
            alt="image"
          />
          <Typography variant="h5" fontWeight={600}>
            GOVERNMENT OF MAHARASHTRA
          </Typography>
          <Typography variant="h5" fontWeight={600}>
            STATE COMMON ENTRANCE TEST CELL, MAHARASHTRA STATE
          </Typography>
          <Typography variant="p" fontWeight={600}>
            8th Floor, New Excelsior Building, A.K.Nayak Marg, Fort,
            Mumbai-400001. (M.S.)
          </Typography>
          <Typography variant="p" sx={{ marginTop: 1 }} fontWeight={600}>
            Application Form for Online Registration For {fullCandidateDetails?.[0]?.coursename}
          </Typography>
          {/* <Typography>APPLICATION FORM</Typography> */}
        </Grid>
        <Grid
          item
          pr={1}
          sx={{ display: "flex", justifyContent: "flex-end", width: "25%" }}
        >
          <img
            style={{ height: "70px", width: "auto" }}
            src={Ara}
            alt="image"
            
          />
        </Grid>
      </Grid>
      <Box sx={{ borderBottom: "1px solid #000" }}>
        {/* {location.pathname + location.search ===
          "/mhcet/course-registration?page=printapplication" &&
          candidateid !== "" && ( */}
            <Typography
              variant="h6"
              sx={{
                textWrap: "wrap",
                fontWeight: "bold",
                color: "#000",
                textAlign: "center",
              }}
            >
              Application No : {fullCandidateDetails?.[0]?.applicantId} {"  "}
              Version No : {fullCandidateDetails?.[0]?.versionno}
            </Typography>
          {/* )} */}
      </Box>
      <Grid container sx={{ width: "100%" }}>
        <Grid item xs={12}>
          <Box
            sx={{
                borderBottom: "1px solid #000",
                display: "flex",
                justifyContent: "space-between",
                padding: 0.5,
                backgroundColor:"#c4c4c4"
              }}
          >
            <Box   sx={{
                display: "flex",
                
              }}>
              <Typography variant="p" sx={{ fontSize: 12, fontWeight: "bold" }}>
                  Personal Details
                </Typography>
            </Box>
          </Box>

          <Grid container xs={12} md={12} >
            <Grid item xs={10} md={10}  sx={{ width: "80%" }}>
              <Grid container xs={12} md={12} >
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Candidate’s Full name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.candidatename || "-"}
                  </Typography>
                </Grid>

                     <Grid
                    item
                    md={7}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {" "}
                      Candidate's Contact Number
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={5}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.mobileno}
                    </Typography>
                  </Grid>

                   <Grid
                    item
                    md={7}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {" "}
                      Candidate's Name (as per HSC / Engineering Diploma/ SSC
                      marksheet)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={5}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.name_as_per_hsc}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={7}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {" "}
                      Candidate's APAAR
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={5}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.user_apaar_id
                        ? fullCandidateDetails?.[0]?.user_apaar_id
                        : "---"}
                    </Typography>
                  </Grid>

                    {fullCandidateDetails?.[0]?.udidnumber && (
                    <>
                      <Grid
                        item
                        md={7}
                        sx={{ border: "1px solid #000", width: "50%" }}
                      >
                        <Typography
                          sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                        >
                          {" "}
                          UDID No.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={5}
                        sx={{ border: "1px solid #000", width: "50%" }}
                      >
                        <Typography
                          sx={{
                            fontSize: 10,
                            px: 1,
                            fontWeight: "bold",
                            textAlign: "left",
                          }}
                        >
                          {fullCandidateDetails?.[0]?.udidnumber}
                        </Typography>
                      </Grid>
                    </>
                  )}

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Father’s Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.fathername}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Mother’s Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.mothername}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Gender
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.gender}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Marital Status
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.maritalstatusid) === 1
                      ? "Married"
                      : parseInt(fullCandidateDetails?.[0]?.maritalstatusid) === 2
                      ? "Unmarried"
                      : "-"}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Spouse Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.length > 0 &&
                      (fullCandidateDetails?.[0]?.spousename || "-")}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Date of Birth
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.dob &&
                      dayjs(fullCandidateDetails?.[0]?.dob).format("DD/MM/YYYY")}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Religion
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.religion}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Region
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.region}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Mother Tongue
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.mothertongue}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Annual Family Income
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.familyincome}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    {" "}
                    Nationality
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.nationality}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "55%" }}
                >
                  <Typography sx={{ fontSize: 10, textAlign: "right", paddingRight:"7px" }}>
                    {" "}
                    {fullCandidateDetails?.[0]?.coursename} Application Fee Paid (&#x20B9;)
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "45%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {/* {fullCandidateDetails?.[0]?.amount} /- */}
                    {fullCandidateDetails?.reduce(
                                (sum, x) => sum + Number(x?.amount),
                                0
                              )} /-
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2} md={2} sx={{ border: "1px solid #000", width: "20%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Box sx={{
                      borderBottom: "3px solid #000",
                      // paddingBottom: "8px",
                      width: "100%",
                      textAlign: "center",
                    }}>
                {photo  && (
                  <img
                    style={{
                      width: "100%",
                      height: "140px",
                      // aspectRatio: "3/4",
                    }}
                    src={photo?.fileurl}
                    alt="Photo"
                  />
                )}</Box>
 <Box
                    sx={{
                      // paddingTop: "10px",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                {signature && (
                  <img
                    style={{
                      width: "120px",
                      height: "75px",
                      backgroundColor: "whitesmoke",
                    }}
                    src={signature?.fileurl}
                    alt="Signature"
                  />
                )}</Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

         {/* Candidate aadhar details */}

          <Grid item xs={12} md={12} sx={{ width: "100%" }}>
            <Box
              sx={{
                border: "1px solid #000",
                display: "flex",
                paddingX: 1,
                backgroundColor: "#c4c4c4",
              }}
            >
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>
                  Candidate Aadhaar Details
                </Typography>
              </Box>
            </Box>
            <Grid container md={12} sx={{ width: "100%" }}>
              {fullCandidateDetails?.[0]?.name_as_per_aadhaar && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Candidate's Name (As per Aadhaar - Auto-fetched)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                        textTransform: "capitalize",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.name_as_per_aadhaar}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.dob_as_per_aadhar && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      DOB (As per Aadhaar)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.dob_as_per_aadhar &&
                        dayjs(
                          fullCandidateDetails?.[0]?.dob_as_per_aadhar,
                          "YYYY-MM-DD"
                        ).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.maskedaadhaar && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Aadhaar No
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.maskedaadhaar}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

        <Grid container xs={12} sm={12} lg={12} sx={{ width: "100%" }}>
          <Grid item xs={6} md={6} sx={{ width: "50%" }}>
            <Box
             sx={{
                  //   height: "48px",
                  //   backgroundColor: "#EDEDED",
                  display: "flex",
                  //   alignItems: "center",
                  // justifyContent: "space-between",
                  border: "1px solid #000",
                  // width: "50%",
                  // borderRadius: "8px 8px 0px 0px",
                  paddingX: 1,
                  backgroundColor:"#c4c4c4"
                }}
            >
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>Permanent Address</Typography>
              </Box>
            </Box>
            <Grid container md={12} sx={{ width: "100%" }}>
              <Grid
                item
                 md={6}
                  sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  {" "}
                  Address Line 1
                </Typography>
              </Grid>
              <Grid
                item
                  md={6}
                  sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: "bold",
                      textAlign: "left",
                    }}
                >
                  {fullCandidateDetails?.[0]?.paddressline1}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
               md={6}
               sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Address Line 2
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.paddressline2}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Address Line 3
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.length > 0 &&
                    (fullCandidateDetails?.[0]?.paddressline3 || "-----")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  State
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.pstate ? fullCandidateDetails?.[0]?.pstate : "Not Available"}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  District
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.pdistrict ? fullCandidateDetails?.[0]?.pdistrict : "Not Applicable"}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Taluka
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.ptaluka ? fullCandidateDetails?.[0]?.ptaluka : "Not Applicable"}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Village
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.pvillage ? fullCandidateDetails?.[0]?.pvillage : "Not Applicable"}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Pincode
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.ppincode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} md={6} lg={6} sx={{ width: "50%" }}>
            <Box
             sx={{
                  border: "1px solid #000",
                  // width: "350px",
                  display: "flex",
                  // justifyContent: "space-between",
                  paddingX: 1,
                  backgroundColor:"#c4c4c4"
                  // borderRadius: "8px 8px 0px 0px",
                }}
            >
              <Box>
                <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>
                  Address for Correspondence
                </Typography>
              </Box>
            </Box>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  {" "}
                  Address Line 1
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.caddressline1}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Address Line 2
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.caddressline2}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Address Line 3
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.length > 0 &&
                    (fullCandidateDetails?.[0]?.caddressline3 || "-----")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  State
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.cstate ? fullCandidateDetails?.[0]?.cstate : "Not Applicable"}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  District
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.cdistrict === null
                    ? "Not Applicable"
                    : fullCandidateDetails?.[0]?.cdistrict}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Taluka
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.ctaluka === null
                    ? "Not Applicable"
                    : fullCandidateDetails?.[0]?.ctaluka}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Village
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.cvillage === null
                    ? "Not Applicable"
                    : fullCandidateDetails?.[0]?.cvillage}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "25%" }}
              >
                <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                  Pincode
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "75%" }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                     fontWeight:"bold",
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.[0]?.cpincode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6} sx={{ border: "1px solid #000", width: "25%" }}>
              <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                {/* Telephone No */}
                Alternate Mobile/ Phone No.
              </Typography>
          </Grid>
          <Grid item md={6} sx={{ border: "1px solid #000", width: "25%" }}>
           
              <Typography
                sx={{
                  fontSize: 10,
                  px: 1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                   fontWeight:"bold",
                  textAlign: "left",
                }}
              >
                {fullCandidateDetails?.[0]?.phoneno}
              </Typography>
         
          </Grid>
          <Grid item md={6} sx={{ border: "1px solid #000", width: "25%" }}>
              <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                STD code
              </Typography>
          </Grid>
          <Grid item md={6} sx={{ border: "1px solid #000", width: "25%" }}>
           
              <Typography
                sx={{
                  fontSize: 10,
                  px: 1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                   fontWeight:"bold",
                  textAlign: "left",
                }}
              >
                {fullCandidateDetails?.[0]?.stdcode}
              </Typography>
         
          </Grid>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box
            sx={{
                border: "1px solid #000",
                display: "flex",
                // justifyContent: "space-between",
                paddingX: 1,
                backgroundColor:"#c4c4c4"
              }}
          >
            <Box>
              <Typography item xs={12} md={12} sx={{ fontSize:12,fontWeight:"bold",width: "100%" }}>
                Domicile and Category Details
              </Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            {fullCandidateDetails?.[0]?.ismhcandidate && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Are You Domiciled In The State Of Maharastra
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.ismhcandidate) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.ismhcandidate) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.category && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Category
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.category}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.castename && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.castename}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.caste && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.caste}
                  </Typography>
                </Grid>
              </>
            )}
            {fullCandidateDetails?.[0]?.castecertificatestatus && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Do You Possess Caste Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.castecertificatestatus) ===
                    1
                      ? "Available"
                      : parseInt(
                          fullCandidateDetails?.[0]?.castecertificatestatus
                        ) === 2
                      ? "Applied But Not Received"
                      : parseInt(
                          fullCandidateDetails?.[0]?.castecertificatestatus
                        ) === 3
                      ? "Not Applied"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

             {fullCandidateDetails?.[0]?.cvcname && (
              <>
                <Grid
                  item
                  md={6}
                  xs={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Candidate Name As Per Caste Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.cvcname}
                  </Typography>
                </Grid>
              </>
            )}

             {fullCandidateDetails?.[0]?.castecertificateno && (
              <>
                <Grid
                  item
                  md={6}
                  xs={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste Certificate/Receipt No
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.castecertificateno}
                  </Typography>
                </Grid>
              </>
            )}

            {((fullCandidateDetails?.[0]?.castevaliditystatus !== null &&
              fullCandidateDetails?.[0]?.castevaliditystatus !== undefined &&
              fullCandidateDetails?.[0]?.castevaliditystatus !== "") ||
              fullCandidateDetails?.[0]?.castevaliditystatus === 0) && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Do You Possess Caste/Tribe Validity Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.castevaliditystatus) === 1
                      ? "Available"
                      : parseInt(fullCandidateDetails?.[0]?.castevaliditystatus) ===
                        2
                      ? "Applied But Not Received"
                      : parseInt(fullCandidateDetails?.[0]?.castevaliditystatus) ===
                        0
                      ? "Not Applied"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.castevaliditycertificateno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste Validity Certificate No
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.castevaliditycertificateno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.cvcapplicationno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Application Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.cvcapplicationno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.cvcapplicationdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {dayjs(fullCandidateDetails?.[0]?.cvcapplicationdate).format("DD/MM/YYYY")}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.cvcauthority && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Issuing Authority Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.cvcauthority}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.cvcdistrict && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Issuing District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.cvcdistrict}
                  </Typography>
                </Grid>
              </>
            )}


            {fullCandidateDetails?.[0]?.castecertificatereceiptno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste Certificate Receipt No
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.castecertificatereceiptno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.castecertificateappdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Caste Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {dayjs(fullCandidateDetails?.[0]?.castecertificateappdate).format("DD/MM/YYYY")}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.appliedforews &&
            fullCandidateDetails?.[0]?.appliedforews != 0 && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Do You Want To Apply For EWS
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.appliedforews) === 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.appliedforews) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.ewscertificatestatus !== null &&
              (fullCandidateDetails?.[0]?.ewscertificatestatus === 0 ||
                fullCandidateDetails?.[0]?.ewscertificatestatus === 1 ||
                fullCandidateDetails?.[0]?.ewscertificatestatus === 2) && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "25%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      EWS Certificate
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "25%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.[0]?.ewscertificatestatus) ===
                      1
                        ? "Available"
                        : parseInt(
                            fullCandidateDetails?.[0]?.ewscertificatestatus
                          ) === 2
                        ? "Not Available"
                        : parseInt(
                            fullCandidateDetails?.[0]?.ewscertificatestatus
                          ) === 0
                        ? "Applied But Not Received"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.ewscertificateno && (
                // {true && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      EWS certificate number
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.ewscertificateno}
                    </Typography>
                  </Grid>
                </>
              )}

            {fullCandidateDetails?.[0]?.ewsapplicationno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    EWS Certificate Application Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.ewsapplicationno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.ewsapplicationdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    EWS Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {dayjs(fullCandidateDetails?.[0]?.ewsapplicationdate).format("DD/MM/YYYY")}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.ewsdistrict && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    EWS Certificate Issuing District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.ewsdistrict}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.ewstaluka && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    EWS Certificate Issuing Taluka
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.ewstaluka}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.nclstatus && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Do You Have Non Creamy Layer Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.nclstatus) === 1
                      ? "Available"
                      : parseInt(fullCandidateDetails?.[0]?.nclstatus) === 2
                      ? "Applied But Not Received"
                      : parseInt(fullCandidateDetails?.[0]?.nclstatus) === 3
                      ? "Not Applied"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.nclapplicationno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Non Creamy Layer Certificate Application Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.nclapplicationno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.nclapplicationdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Non Creamy Layer Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {dayjs(fullCandidateDetails?.[0]?.nclapplicationdate).format("DD/MM/YYYY")}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.nclauthority && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "25%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "right",
                        textWrap: "wrap",
                      }}
                    >
                      Non Creamy Layer Certificate Issuing Authority Name
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "25%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.nclauthority}
                    </Typography>
                  </Grid>
                </>
              )}
           
          </Grid>
          {/* {(fullCandidateDetails?.isminority ||
              fullCandidateDetails?.linguisticminority ||
              fullCandidateDetails?.religiousminority) && (
              <>
                <Box
                  sx={{
                    border: "1px solid #000",
                    marginTop: ".1rem",
                    width: "100%",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: 18 }}>
                      Minority Information
                    </Typography>
                  </Box>
                </Box>
              </>
            )} */}
          <Grid container md={12}>
            {fullCandidateDetails?.[0]?.isdisability && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Are You Person With Disability
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.isdisability) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.isdisability) == 0
                      ? "No"
                      : "---"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.pwdtype && 
            fullCandidateDetails?.[0]?.isdisability != 0 &&(
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Type Of Disability
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.pwdtype}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.pwdsubtype &&
            fullCandidateDetails?.[0]?.isdisability != 0 && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    PWD Sub Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.pwdsubtype}
                  </Typography>
                </Grid>
              </>
            )}

             {fullCandidateDetails?.[0]?.disabilitynature &&
                fullCandidateDetails?.[0]?.isdisability != 0 && (
                  <>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        Nature of Disability
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {parseInt(fullCandidateDetails?.[0]?.disabilitynature) == 1
                          ? "Permanent"
                          : parseInt(
                              fullCandidateDetails?.[0]?.disabilitynature
                            ) == 0
                          ? "Temporary"
                          : "----"}
                      </Typography>
                    </Grid>
                  </>
                )}
              
                 {fullCandidateDetails?.[0]?.disabilitypercentage &&
                fullCandidateDetails?.[0]?.isdisability != 0 && (
                  <>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        Disability Percentage
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {parseInt(
                          fullCandidateDetails?.[0]?.disabilitypercentage
                        ) == 0
                          ? "Less than 40%"
                          : parseInt(
                              fullCandidateDetails?.[0]?.disabilitypercentage
                            ) == 1
                          ? "40% and above"
                          : "N/A"}
                      </Typography>
                    </Grid>
                  </>
                )}

            {fullCandidateDetails?.[0]?.isextratime && 
           fullCandidateDetails?.[0]?.isdisability != 0 && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Require Extra Time
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.isextratime) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.isextratime) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.isscribe &&
            fullCandidateDetails?.[0]?.isdisability != 0 && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Require Scribe
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.isscribe) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.isscribe) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          <Grid container md={12}>
            {fullCandidateDetails?.[0]?.isminority && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Do You Belong To Minority Category
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.isminority) === 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.isminority) === 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.linguisticminority && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Linguistic Minority
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.linguisticminority}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.religiousminority && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Religious Minority
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.religiousminority}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>


                          {fullCandidateDetails?.[0]?.isoci && (
                  <>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        OCI Card Status
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {parseInt(fullCandidateDetails?.[0]?.isoci) === 1
                          ? "Yes"
                          : parseInt(fullCandidateDetails?.[0]?.isoci) === 0
                            ? "No"
                            : "----"}
                      </Typography>
                    </Grid>
                  </>
                )}

                                {fullCandidateDetails?.[0]?.ocidate && (
                  <>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        OCI Status Obtained Date
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.ocidate}

                      </Typography>
                    </Grid>
                  </>
                )}

          {(fullCandidateDetails?.[0]?.isorphan ||
            fullCandidateDetails?.[0]?.orphantype) && (
            <>
              <Box
                sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      // border: "1px solid #000",
                      // marginTop: ".1rem",
                      width: "100%",
                      paddingX: 1,
                      backgroundColor:"#c4c4c4"
                    }}
              >
                <Box>
                  <Typography  sx={{ fontSize: 12, fontWeight: "bold" }}>
                    Orphan Details
                  </Typography>
                </Box>
              </Box>
            </>
          )}
          <Grid container md={12}>
            {fullCandidateDetails?.[0]?.isorphan && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Are You Orphan
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.isorphan) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.[0]?.isorphan) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.orphantype && (
              <>
                <Grid item md={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "right",
                      width: "50%",
                    }}
                  >
                    Orphan Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.orphantype}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          <Grid container md={12}>
            {(fullCandidateDetails?.[0]?.issports ||
              fullCandidateDetails?.[0]?.sportsparticipation ||
              fullCandidateDetails?.[0]?.sportsparticipationyear ||
              fullCandidateDetails?.[0]?.sportsrank ||
              fullCandidateDetails?.[0]?.sports ||
              fullCandidateDetails?.[0]?.sportsbody ||
              fullCandidateDetails?.isphysicaleducation ||
              fullCandidateDetails?.[0]?.isteachingexperience ||
              fullCandidateDetails?.[0]?.isappliedforelct ||
              fullCandidateDetails?.[0]?.isappliedforksu ||
              fullCandidateDetails?.[0]?.isappliedforspecialeducation ||
              fullCandidateDetails?.[0]?.specialeducationmethods) && (
            <>
              <Box
                sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      // border: "1px solid #000",
                      // marginTop: ".1rem",
                      width: "100%",
                      paddingX: 1,
                      backgroundColor:"#c4c4c4"
                    }}
              >
                <Box>
                  <Typography  sx={{ fontSize: 12, fontWeight: "bold" }}>
                    Sports Information
                  </Typography>
                </Box>
              </Box>
            </>
            )}
            <Grid container md={12}>
              {fullCandidateDetails?.[0]?.issports && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Participated in Sports
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.[0]?.issports) === 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.sportsparticipation && 
               fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Sports Participation Level
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.sportsparticipation}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.sportsparticipationyear &&
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Sports Participation Year
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.sportsparticipationyear}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.sportsrank && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Sports Rank
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.sportsrank}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.sports && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Sports Name
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.sports}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.sportsbody && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Sports Body
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.sportsbody}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.isphysicaleducation && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Is Studied Physical Education
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.[0]?.isphysicaleducation) == 1
                        ? "Yes"
                        : parseInt(fullCandidateDetails?.[0]?.isphysicaleducation) ==
                          0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.isteachingexperience && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Is Teaching Experience
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight:"bold"
                      }}
                    >
                      {parseInt(fullCandidateDetails?.[0]?.isteachingexperience) == 1
                        ? "Yes"
                        : parseInt(
                            fullCandidateDetails?.[0]?.isteachingexperience
                          ) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.isappliedforelct && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Is Applied For ELCT
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.[0]?.isappliedforelct) == 1
                        ? "Yes"
                        : parseInt(fullCandidateDetails?.[0]?.isappliedforelct) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.isappliedforksu && 
              fullCandidateDetails?.[0]?.issports != 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Is Applied For KSU
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "25%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.[0]?.isappliedforksu) == 1
                        ? "Yes"
                        : parseInt(fullCandidateDetails?.[0]?.isappliedforksu) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.isappliedforspecialeducation && 
              fullCandidateDetails?.[0]?.issports != 0 &&(
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Is Applied For Special Education
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(
                        fullCandidateDetails?.[0]?.isappliedforspecialeducation
                      ) == 1
                        ? "Yes"
                        : parseInt(
                            fullCandidateDetails?.[0]?.isappliedforspecialeducation
                          ) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.specialeducationmethods && 
              fullCandidateDetails?.[0]?.issports != 0 &&(
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Special Education Methods
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        fontWeight:"bold",
                        color: "black",
                      }}
                    >
                      {parseInt(
                        fullCandidateDetails?.[0]?.specialeducationmethods
                      ) == 1
                        ? "Yes"
                        : parseInt(
                            fullCandidateDetails?.[0]?.specialeducationmethods
                          ) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>

            <Box
              sx={{
                border: "1px solid #000",
                marginTop: ".1rem",
                width: "100%",
              }}
            >
              {/* <Box>
                <Typography sx={{ fontSize: 18 }}>
                  Category information
                </Typography>
              </Box> */}
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {(fullCandidateDetails?.[0]?.sscpassedfromindia ||
            fullCandidateDetails?.[0]?.sscschoolstate ||
            fullCandidateDetails?.[0]?.sscschooldistrict ||
            fullCandidateDetails?.[0]?.sscschooltaluka ||
            fullCandidateDetails?.[0]?.sscpassingyear ||
            fullCandidateDetails?.[0]?.sscboard ||
            fullCandidateDetails?.[0]?.sscschoolname ||
            fullCandidateDetails?.[0]?.ssctotalpercentage) && (
            <>
              <Box
               sx={{
                      border: "1px solid #000",
                      display: "flex",
                      // justifyContent: "space-between",
                      paddingX: 1,
                      backgroundColor:"#c4c4c4"
                    }}
              >
                <Box>
                  <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>
                    Qualification Details
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  border: "1px solid #000",
                  marginTop: ".1rem",
                }}
              >
                <Box sx={{
                      border: "1px solid #000",
                      // marginTop: ".1rem",
                      display: "flex",
                      justifyContent: "space-between",
                      paddingX: 1,
                      width: "100%",
                      backgroundColor:"#c4c4c4"
                    }}>
                      <Box>
                  <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>SSC Details</Typography>
                  </Box>
                </Box>
              </Box>
            </>
          )}

          <Grid container md={12}>
            {fullCandidateDetails?.[0]?.sscpassedfromindia && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC Passed From India
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.sscpassedfromindia == 1
                      ? "Yes"
                      : fullCandidateDetails?.[0]?.sscpassedfromindia == 0
                      ? "No"
                      : "---"}
                  </Typography>
                </Grid>
              </>
            )}
            {fullCandidateDetails?.[0]?.sscschooldistrict && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC School District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.sscschooldistrict}
                  </Typography>
                </Grid>
              </>
            )}
            
            {fullCandidateDetails?.[0]?.sscschooltaluka && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC School Taluka
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.sscschooltaluka}
                  </Typography>
                </Grid>
              </>
            )}

              {fullCandidateDetails?.[0]?.sscpassingyear && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC/Equivalent Passing Year
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.sscpassingyear}
                  </Typography>
                </Grid>
              </>
            )}

             {fullCandidateDetails?.[0]?.sscpassingmonth && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      SSC/Equivalent Passing Month
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {
                         fullCandidateDetails?.[0]?.sscpassingmonth
                      }
                    </Typography>
                  </Grid>
                </>
            )}

                {fullCandidateDetails?.[0]?.sscseatno && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      SSC/Equivalent Seat Number
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                      px={1}
                    >
                      {fullCandidateDetails?.[0]?.sscseatno}
                    </Typography>
                  </Grid>
                </>
            )}

             {fullCandidateDetails?.[0]?.sscclass && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      SSC/Equivalent Class
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                      px={1}
                    >
                      {/* {fullCandidateDetails?.[0]?.sscclass} */}
                      {
                        
                            fullCandidateDetails?.[0]?.sscclass
                      }
                    </Typography>
                  </Grid>
                </>
            )}

             {fullCandidateDetails?.[0]?.sscotherboardname &&
                fullCandidateDetails?.[0]?.sscboard == "Any Other Board" && (
                  <>
                    <Grid
                      item
                      md={6}
                      xs={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                        px={1}
                      >
                        SSC/Equivalent other Board 
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                    
                      xs={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                        px={1}
                      >
                        {fullCandidateDetails?.[0]?.sscotherboardname}
                      </Typography>
                    </Grid>
                  </>
            )}

             {fullCandidateDetails?.[0]?.sscschoolname && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      SSC School Name
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.sscschoolname}
                    </Typography>
                  </Grid>
                </>
            )}

               {fullCandidateDetails?.[0]?.ssctotalpercentage && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC/Equivalent Percentage
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.ssctotalpercentage}
                  </Typography>
                </Grid>
              </>
            )}

             {fullCandidateDetails?.[0]?.sscboard && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC/Equivalent Board
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.sscboard}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.sscschoolstate && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    SSC passing state
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.sscschoolstate}
                  </Typography>
                </Grid>
              </>
            )}        
                                              
          </Grid>
          {(fullCandidateDetails?.[0]?.hsccollegestate ||
            fullCandidateDetails?.[0]?.hsccollegedistrict ||
            fullCandidateDetails?.[0]?.hsccollegetaluka ||
            fullCandidateDetails?.[0]?.hsccollegename ||
            fullCandidateDetails?.[0]?.hscmarktype ||
            fullCandidateDetails?.[0]?.hscmarksobtained ||
            fullCandidateDetails?.[0]?.hscmarksoutof ||
            fullCandidateDetails?.[0]?.hscpercentage ||
            fullCandidateDetails?.[0]?.hscenglishmarksobtained ||
            fullCandidateDetails?.[0]?.hscenglishmarksoutof ||
            fullCandidateDetails?.[0]?.hscenglishpercentage ||
            fullCandidateDetails?.[0]?.hscpassingyear ||
            fullCandidateDetails?.[0]?.hscpassingstatus ||
            fullCandidateDetails?.[0]?.hscboard) && (
            <Box
              sx={{
                    // border: "1px solid #000",
                    marginTop: ".1rem",
                    paddingX: 1,
                    width: "100%",
                    backgroundColor:"#c4c4c4"
                  }}
            >
              <Box>
                <Typography  sx={{ fontSize: 12, fontWeight: "bold" }}>HSC / Engineering Diploma Details</Typography>
              </Box>
            </Box>
          )}
          <Grid container md={12} sx={{ width: "100%" }}>
             {fullCandidateDetails?.[0]?.hscpassingstatus && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {/* Are you Appearing /Appeared 12th (HSC) exam in 2026{" "} */}
                      HSC / Engineering Diploma Appearing Status
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.hscpassingstatus == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}
            {fullCandidateDetails?.[0]?.hsccollegestate && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    HSC / Engineering Diploma College State
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hsccollegestate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.hsccollegedistrict && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                     HSC / Engineering Diploma College District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hsccollegedistrict}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.hsccollegetaluka && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    HSC / Engineering Diploma College Taluka
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hsccollegetaluka}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.hscpassingyear && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                     HSC / Engineering Diploma Passing Year
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hscpassingyear}
                  </Typography>
                </Grid>
              </>
            )}
{fullCandidateDetails?.[0]?.hscotherboardname &&
                fullCandidateDetails?.[0]?.sscboard == "Any Other Board" && (
                  <>
                    <Grid
                      item
                      md={6}
                      xs={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                        px={1}
                      >
                        HSC / Engineering Diploma Equivalent other Board
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                    
                      xs={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                        px={1}
                      >
                        {fullCandidateDetails?.[0]?.hscotherboardname}
                      </Typography>
                    </Grid>
                  </>
                )}
                 {fullCandidateDetails?.[0]?.hscpassingmonth && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      HSC / Engineering Diploma Passing Month
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                      px={1}
                    >
                      {
                         fullCandidateDetails?.[0]?.hscpassingmonth
                      }
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.hscstream && (
                <>
                  <Grid
                    item
                    md={6}
                    px={1}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                    >
                     HSC / Engineering Diploma Stream
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {/* {fullCandidateDetails?.[0]?.hscstream} */}
                                              {
                          educationStreamList?.all?.find(
                            (obj) =>
                              obj.educationstreamid ==
                              fullCandidateDetails?.[0]?.hscstream
                          )?.educationstream
                        }
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.hscseatno && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      HSC / Engineering Diploma Seat Number
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.hscseatno}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.hscclass && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      HSC / Engineering Diploma Class
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                      px={1}
                    >
                      {/* {fullCandidateDetails?.[0]?.hscclass} */}
                      {/* {
                       
                            fullCandidateDetails?.[0]?.hscclass
                      } */}

                      {
                          educationClassList?.all?.find(
                            (obj) =>
                              obj.educationclassid ==
                              fullCandidateDetails?.[0]?.hscclass
                          )?.educationclass
                        }
                    </Typography>
                  </Grid>
                </>
              )}
            {fullCandidateDetails?.[0]?.hscboard && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    HSC / Engineering Diploma Board
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hscboard}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.hsccollegename && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                   HSC / Engineering Diploma College Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hsccollegename}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.hscmarktype && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Marks Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.hscmarktype) === 1
                      ? "CGPA"
                      : parseInt(fullCandidateDetails?.[0]?.hscmarktype) === 2
                      ? "Percentage"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}
            {fullCandidateDetails?.[0]?.hscmarksobtained && (
                           <Table sx={{ border: "1px solid #000", borderCollapse: "collapse", width: "100%", fontSize: "10px" }}>
                    <colgroup>
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                    </colgroup>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>Qualification</TableCell>
                  <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>Marks Obtained</TableCell>
                  <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>Marks Out Of</TableCell>
                  <TableCell sx={{ border: "1px solid #000", fontWeight: "bold", textAlign: "center",padding:"0px!important",fontSize:"12px" }}>Percentage</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #000", textAlign: "center",fontSize:"10px" ,padding:"0px 4px!important" }}>HSC / Engineering Diploma</TableCell>
                  <TableCell sx={{ border: "1px solid #000", textAlign: "center", fontWeight: "bold",fontSize:"10px" ,padding:"0px 4px!important" }}>
                    {fullCandidateDetails?.[0]?.hscmarksobtained || ""}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #000", textAlign: "center", fontWeight: "bold",fontSize:"10px" ,padding:"0px 4px!important" }}>
                    {fullCandidateDetails?.[0]?.hscmarksoutof || ""}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid #000", textAlign: "center", fontWeight: "bold",fontSize:"10px" ,padding:"0px 4px!important" }}>
                    {fullCandidateDetails?.[0]?.hscpercentage || ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>)}

            {/* {fullCandidateDetails?.[0]?.hscenglishmarksobtained && (
              <>
                <Grid
                  item
                  md={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    HSC / Engineering Diploma English Marks Obtained
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hscenglishmarksobtained}
                  </Typography>
                </Grid>
              </>
            )}
            

            {fullCandidateDetails?.[0]?.hscenglishmarksoutof && (
              <>
                <Grid
                  item
                  md={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    HSC / Engineering Diploma English Marks Out Of
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hscenglishmarksoutof}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.hscenglishpercentage && (
              <>
                <Grid
                  item
                  md={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                     HSC / Engineering Diploma English Percentage
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  sx={{ border: "1px solid #000", width: "25%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.hscenglishpercentage}
                  </Typography>
                </Grid>
              </>
            )} */}

                            {fullCandidateDetails?.[0]?.hscenglishmarksobtained && (
                  <Table
                    sx={{
                      border: "1px solid #000",
                      borderCollapse: "collapse",
                      width: "100%",
                      fontSize: "10px",
                      tableLayout: "fixed",
                    }}
                  >
                    <colgroup>
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                      <col style={{ width: "25%" }} />
                    </colgroup>
                    {/* <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "0px!important",
                            fontSize: "12px",
                          }}
                        >
                          Qualification
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "0px!important",
                            fontSize: "12px",
                          }}
                        >
                          Marks Obtained
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "0px!important",
                            fontSize: "12px",
                          }}
                        >
                          Marks Out Of
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "0px!important",
                            fontSize: "12px",
                          }}
                        >
                          Percentage
                        </TableCell>
                      </TableRow>
                    </TableHead> */}

                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "0px 4px!important",
                          }}
                        >
                          HSC English
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "0px 4px!important",
                          }}
                        >
                          {fullCandidateDetails?.[0]?.hscenglishmarksobtained || ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "0px 4px!important",
                          }}
                        >
                          {fullCandidateDetails?.[0]?.hscenglishmarksoutof || ""}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #000",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "0px 4px!important",
                          }}
                        >
                          {fullCandidateDetails?.[0]?.hscenglishpercentage || ""}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}


          </Grid>

          {(fullCandidateDetails?.[0]?.eligibilityqualification ||
            fullCandidateDetails?.[0]?.graduationstatus ||
            fullCandidateDetails?.[0]?.graduationpassingyear ||
            fullCandidateDetails?.[0]?.graduationbranch ||
            fullCandidateDetails?.[0]?.graduationmarktype ||
            fullCandidateDetails?.[0]?.graduationmarksobtained ||
            fullCandidateDetails?.[0]?.graduationmarksoutof ||
            fullCandidateDetails?.[0]?.graduationpercentage ||
            fullCandidateDetails?.[0]?.awardedclass ||
            fullCandidateDetails?.[0]?.gradudationduration ||
              fullCandidateDetails?.[0]?.guniversityname) && (
            <Box
               sx={{
                    // border: "1px solid #000",
                    marginTop: ".1rem",
                    paddingX: 1,
                    width: "100%",
                    backgroundColor:"#c4c4c4"
                  }}
            >
              <Box>
                <Typography  sx={{ fontSize: 12, fontWeight: "bold" }}>
                  Graduation Information
                </Typography>
              </Box>
            </Box>
          )}
          <Grid container md={12}>
            {/* {fullCandidateDetails?.[0]?.eligibilityqualification && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Eligiblity Qualification
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.eligibilityqualification}
                  </Typography>
                </Grid>
              </>
            )} */}

            {fullCandidateDetails?.[0]?.graduationstatus && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Status
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.graduationstatus == 1
                      ? "Appearing"
                      : fullCandidateDetails?.[0]?.graduationstatus == 2
                      ? "Passed"
                      : fullCandidateDetails?.[0]?.graduationstatus == 0
                      ? "Not Applicable"
                      : "---"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.graduationpassingyear && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Passing Year
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.graduationpassingyear}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.graduationbranch && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Branch Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.graduationbranch}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.graduationmarktype && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Marks Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.[0]?.graduationmarktype) == 1
                      ? "Percentage"
                      : parseInt(fullCandidateDetails?.[0]?.graduationmarktype) === 2
                      ? "CGPA"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.graduationmarksobtained && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Marks Obtained
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.graduationmarksobtained}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.graduationmarksoutof && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Marks Out Of
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.graduationmarksoutof}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.graduationpercentage && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Graduation Percentage
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.graduationpercentage}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.[0]?.awardedclass && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Class Awarded
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.awardedclass}
                  </Typography>
                </Grid>
              </>
            )}


                        {fullCandidateDetails?.[0]?.gradudationduration && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                     {`Graduation Duration (in Years)`}{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.gradudationduration}
                  </Typography>
                </Grid>
              </>
            )}


{/* 
                        {fullCandidateDetails?.[0]?.gradudationduration && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                     {`Graduation Duration (in Years)`}{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.gradudationduration}
                  </Typography>
                </Grid>
              </>
            )} */}

                          {fullCandidateDetails?.[0]?.gotheruniversitystate && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Graduation University State
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                          {
                            fullCandidateDetails?.[0]?.gotheruniversitystate
                              ? stateList?.all
                                ?.filter(state =>
                                  state?.stateid === fullCandidateDetails?.[0]?.gotheruniversitystate
                                )
                                ?.map(val => {
                                  return val?.state;
                                })
                                ?.join(", ")
                              : "Not Applicable"
                          }                   
                    </Typography>
                  </Grid>
                </>
              )}

                            {fullCandidateDetails?.[0]?.gcollegename && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      College Name
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gcollegename}
                    </Typography>
                  </Grid>
                </>
              )}

                            {fullCandidateDetails?.[0]?.guniversityname && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Name of University(Graduation)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.guniversityname}
                    </Typography>
                  </Grid>
                </>
              )}

                            {fullCandidateDetails?.[0]?.gpassingmonth && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Graduation Passing Month
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {/* {fullCandidateDetails?.[0]?.gpassingmonth} */}
                          {
                            fullCandidateDetails?.[0]?.gpassingmonth
                              ? new Date(0, fullCandidateDetails?.[0]?.gpassingmonth - 1)
                                .toLocaleString("en-US", { month: "long" })
                              : "Not Applicable"
                          }
                    </Typography>
                  </Grid>
                </>
              )}

                             {fullCandidateDetails?.[0]?.gspecialsubject?.length > 0 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Graduation Specialization or Subject
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                      }}
                    >
                      {/* {fullCandidateDetails?.[0]?.gspecialsubject?.[0] === 0
                        ? "Not Applicable"
                        : gspecializationSubjectList[0]?.filter((obj) =>
                              fullCandidateDetails?.[0]?.gspecialsubject?.includes(obj?.gspecializationid))?.map((val) => val?.gspecializaiton)
                            .join(", ")} */}


                          {
                            fullCandidateDetails?.[0]?.gspecialsubject?.[0] === 0
                              ? "Not Applicable"
                              : gspecializationSubjectList?.all
                                ?.filter(obj => {
                                  const match = fullCandidateDetails?.[0]?.gspecialsubject?.includes(
                                    obj?.gspecializationid
                                  );
                                  return match;
                                })
                                ?.map(val => {
                                  return val?.gspecializaiton;
                                })
                                ?.join(", ")
                          }
                    </Typography>
                  </Grid>
                </>
              )}

            {/* {fullCandidateDetails?.[0]?.gradudationduration && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                     {`Graduation Duration (in Years)`}{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "50%" }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.gradudationduration}
                  </Typography>
                </Grid>
              </>
            )} */}
            
              {fullCandidateDetails?.[0]?.documentfortypea && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Document For Type A{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {
                        
                             docTypes.find(
                          (doc) =>
                            doc.value ===
                            fullCandidateDetails?.[0]?.documentfortypea
                        )?.label
                      }
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.documentof && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Document Of{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {
                        docTypeNo.find(
                          (doc) =>
                            doc.value === fullCandidateDetails?.[0]?.documentof
                        )?.label
                      }
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.cetexamname &&
                fullCandidateDetails?.[0]?.cetexamname != "undefined" && (
                  <>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        Examination{" "}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {
                         fullCandidateDetails?.[0]?.cetexamname
                        }
                        {/* {fullCandidateDetails?.[0]?.cetexamname} */}
                      </Typography>
                    </Grid>
                  </>
                )}

              {fullCandidateDetails?.[0]?.pfgraduationdate && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`PF Graduation Date `}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {dayjs(fullCandidateDetails?.[0]?.pfgraduationdate).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.internshiptrainingdate && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`Internship Training Date `}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {dayjs(fullCandidateDetails?.[0]?.internshiptrainingdate).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                </>
              )}

                          {fullCandidateDetails?.[0]?.pgpassingdate ? (
                                    <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Date of Passing Final Graduation`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {dayjs(fullCandidateDetails?.[0]?.pgpassingdate).format("DD/MM/YYYY")}
                          </Typography>
                        </Grid>
                      </>
            ) : null}

            {fullCandidateDetails?.[0]?.pgpinterncompleteddate ? (
                                    <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Internship Training Date of Completion / Likely to complete (Before 31/10/25)`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {dayjs(fullCandidateDetails?.[0]?.pgpinterncompleteddate).format("DD/MM/YYYY")}
                          </Typography>
                        </Grid>
                      </>
            ) : null}

              {fullCandidateDetails?.[0]?.councilregdate && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`MH Council Registration `}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {dayjs(fullCandidateDetails?.[0]?.councilregdate).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.recouncilregdate && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`Re Council Registration `}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {dayjs(fullCandidateDetails?.[0]?.recouncilregdate).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                </>
              )}

              {/* {fullCandidateDetails?.[0]?.pgotptreg!=null && fullCandidateDetails?.[0]?.graduationstatus!==1  ? (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Maharashtra OT/PT Council Registration for B.P.Th. / B.O.Th.
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.pgotptreg === 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </>
              ) : null}

              {fullCandidateDetails?.[0]?.pgrcireg!==null && fullCandidateDetails?.[0]?.graduationstatus!==1 ? (
                <>
                    <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Rehabilitation Council of India Registration (for BASLP, B.Sc (Speech & Hearing), BPO, and B.Sc (P&O))`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgrcireg == 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                </>
              ) : null} */}
               {fullCandidateDetails?.[0]?.pgotptreg != null ? (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Are you registered with Maharashtra State Occupational Therapy and Physiotherapy Council?
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.pgotptreg === 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </>
              ) : null}
              {fullCandidateDetails?.[0]?.pgotptreg != null && fullCandidateDetails?.[0]?.graduationstatus !== 1 && fullCandidateDetails?.[0]?.pgotptreg != 1 && fullCandidateDetails?.[0]?.appliedpgotptreg != null ? (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Have you applied for registration with Maharashtra State Occupational Therapy and Physiotherapy Council?
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.appliedpgotptreg == 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </>
              ) : null}

              {fullCandidateDetails?.[0]?.pgrcireg == null ? null : (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`Are you registered with Rehabilitation Council of India (RCI)?`}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.pgrcireg == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}
              {fullCandidateDetails?.[0]?.pgrcireg !== null && fullCandidateDetails?.[0]?.graduationstatus !== 1 && fullCandidateDetails?.[0]?.pgrcireg != 1 && fullCandidateDetails?.[0]?.appliedpgrcireg != null ? (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`Have you applied for registration with the Rehabilitation Council of India?`}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                       {fullCandidateDetails?.[0]?.appliedpgrcireg == 1
                        ? "Yes"
                         : "No"} 
                    </Typography>
                  </Grid>
                </>
              ) : null}
              {fullCandidateDetails?.[0]?.pgotptreg != null && fullCandidateDetails?.[0]?.graduationstatus !== 1 && fullCandidateDetails?.[0]?.pgotptreg != 1 && fullCandidateDetails?.[0]?.appliedpgotptreg != null ? (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Have you applied for registration with Maharashtra State Occupational Therapy and Physiotherapy Council?
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.appliedpgotptreg == 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </>
              ) : null}

              {fullCandidateDetails?.[0]?.pgrcireg !== null && fullCandidateDetails?.[0]?.graduationstatus !== 1 ? (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`Are you registered with Rehabilitation Council of India (RCI)?`}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.pgrcireg == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              ) : null}
              {fullCandidateDetails?.[0]?.pgrcireg !== null && fullCandidateDetails?.[0]?.graduationstatus !== 1 && fullCandidateDetails?.[0]?.pgrcireg != 1 && fullCandidateDetails?.[0]?.appliedpgrcireg != null ? (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      {`Have you applied for registration with the Rehabilitation Council of India?`}{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                       {fullCandidateDetails?.[0]?.appliedpgrcireg == 1
                        ? "Yes"
                         : "No"} 
                    </Typography>
                  </Grid>
                </>
              ) : null}



              {fullCandidateDetails?.[0]?.ispgmh!==null && fullCandidateDetails?.[0]?.graduationstatus!==1 ? (
                <>
                                          <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Whether passed Graduation from Institution situated in
                            Maharashtra{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.ispgmh === 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                </>
              ) : null}

              {fullCandidateDetails?.[0]?.isadmittedpg!==null && fullCandidateDetails?.[0]?.graduationstatus!==1 ? (
                <>
                                                                <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`
If Already admitted and Pursuing P.G. Course M.P.Th./M.O.Th./M.S.L.P./MSc. (P & O)`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {/* {
                              YesOrNo.find(
                                (doc) =>
                                  doc.value ===
                                  fullCandidateDetails?.[0]?.isadmittedpg
                              )?.label
                            } */}

                            {
                     fullCandidateDetails?.[0]?.isadmittedpg === 1 ? "Yes" : "No"
                      }
                          </Typography>
                        </Grid>
                </>
              ) : null}





              {fullCandidateDetails?.[0]?.gstudiedmath!==null && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Have you Studied/Appearing Mathematics as one of the
                      subjects at (10+2) level or at Graduate level examination?
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gstudiedmath === 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {/* {fullCandidateDetails?.[0]?.gstudiedmath && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Have you Studied/Appearing Mathematics as one of the
                      subjects at (10+2) level or at Graduate level examination?
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gstudiedmath === 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </>
              )} */}

              {fullCandidateDetails?.[0]?.ispassedbefore1975 && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                     Have You Passed SSC/ HSC / Engineering Diploma
                     Pre-University Examination before the Year 1975?{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.ispassedbefore1975 === 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {/* <Grid container> */}
              

              {fullCandidateDetails?.[0]?.alreadyadmitted && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Already Admitted{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {
                       
                            fullCandidateDetails?.[0]?.alreadyadmitted
                      }
                    </Typography>
                  </Grid>
                </>
              )}

              {/* {fullCandidateDetails?.[0]?.gotheruniversitystate && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Graduation University State
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                          {
                            fullCandidateDetails?.[0]?.gotheruniversitystate
                              ? stateList?.all
                                ?.filter(state =>
                                  state?.stateid === fullCandidateDetails?.[0]?.gotheruniversitystate
                                )
                                ?.map(val => {
                                  return val?.state;
                                })
                                ?.join(", ")
                              : "Not Applicable"
                          }                   
                    </Typography>
                  </Grid>
                </>
              )} */}

              {/* {fullCandidateDetails?.[0]?.gcollegename && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      College Name
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gcollegename}
                    </Typography>
                  </Grid>
                </>
              )} */}

              {fullCandidateDetails?.[0]?.isgraduationfromclg && fullCandidateDetails?.[0]?.graduationstatus!==1 && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      I have passed graduation from College
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.isgraduationfromclg}
                    </Typography>
                  </Grid>
                </>
              )}

              {/* {fullCandidateDetails?.[0]?.guniversityname && (
                <>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      Name of University(Graduation)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.guniversityname}
                    </Typography>
                  </Grid>
                </>
              )} */}

                {fullCandidateDetails?.[0]?.gotherdegreename && (
                  <>
                    <Grid
                      item
                      md={6}
                      xs={6}
                      p={1}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      >
                        Graduation Other Degree Name
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      xs={6}
                      p={1}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.gotherdegreename}
                      </Typography>
                    </Grid>
                  </>
                )}

              {fullCandidateDetails?.[0]?.gotheruniversityname && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "left", color: "#000" }}
                    >
                      Graduation Other University Name
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gotheruniversityname}
                    </Typography>
                  </Grid>
                </>
              )}


              {/*  */}

              {fullCandidateDetails?.[0]?.gmathssubject && (
                <>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      {/* Graduation Mathematics Subject */}
                       {`Mathematics mandatory subject (10 + 2 ) / Graduation`}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gmathssubject == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.gexampassbefore1975 && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Graduation Exam Pass Before 1975
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {/* {fullCandidateDetails?.[0]?.gexampassbefore1975} */}
                      {fullCandidateDetails?.[0]?.gexampassbefore1975 == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {/* {fullCandidateDetails?.[0]?.gengmediumcollege && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Graduation English Medium College
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.gengmediumcollege == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )} */}

              {fullCandidateDetails?.[0]?.genglangcontenttest && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Graduation English Language Contest Test
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                      px={1}
                    >
                      {/* {fullCandidateDetails?.[0]?.genglangcontenttest} */}
                      {fullCandidateDetails?.[0]?.genglangcontenttest == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {/* {fullCandidateDetails?.[0]?.goptspecialedcollege && (
                <>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Graduation Optional special Ed College
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                      px={1}
                    >
                      {fullCandidateDetails?.[0]?.goptspecialedcollege == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )} */}

             

             {/* {fullCandidateDetails?.[0]?.graduationstatus === 2 && (<MarksTable fullCandidateDetails={fullCandidateDetails} />)} */}
           
          </Grid>
{(fullCandidateDetails?.[0]?.councilregappno ||
              fullCandidateDetails?.[0]?.applicationdate ||
              fullCandidateDetails?.[0]?.pgpedupreference1 ||
              fullCandidateDetails?.[0]?.pgpedupreference2 ||
              fullCandidateDetails?.[0]?.pgpedupreference3 ||
              fullCandidateDetails?.[0]?.pgstatus) && (
                <>
                  <Box
                    sx={{
                      // border: "1px solid #000",
                      marginTop: ".1rem",
                      paddingX: 1,
                      width: "100%",
                      backgroundColor:"#c4c4c4"
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>
                        Post Graduation Information
                      </Typography>
                    </Box>
                  </Box>

                  <Grid container md={12} sx={{ width: "100%" }}>
                    {/* {fullCandidateDetails?.[0]?.eligibilityqualification && (
              <> */}
                    {/* <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Document For Type A
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                 Document Of
</Typography>
                </Grid> */}
                    {/* </>
            )} */}

                    {fullCandidateDetails?.[0]?.pgstatus && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Status
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgstatus == 1
                              ? "Appearing"
                              : fullCandidateDetails?.[0]?.pgstatus == 2
                                ? "Passed"
                                : ""}{" "}
                          </Typography>
                        </Grid>
                      </>
                    )}

                    {fullCandidateDetails?.[0]?.pgpassingyear && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Passing Year{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgpassingyear}
                          </Typography>
                        </Grid>
                      </>
                    )}

                    {fullCandidateDetails?.[0]?.pgbranchid && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Branch Name / Degree
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {/* {fullCandidateDetails?.[0]?.pgbranchid} */}
                            {/* {
                                fullCandidateDetails?.[0]?.pgbranchid
                                  ? pgBranchList
                                    ?.find(branch =>
                                      branch?.pgbranchid === fullCandidateDetails?.[0]?.pgbranchid
                                    )
                                    ?.pgbranch || "Not Applicable"
                                  : "Not Applicable"
                              } */}

                          {
                            fullCandidateDetails?.[0]?.pgbranchid
                              ? pgBranchList?.all
                                ?.filter(state =>
                                  state?.pgbranchid === fullCandidateDetails?.[0]?.pgbranchid
                                )
                                ?.map(val => {
                                  return val?.pgbranch;
                                })
                                ?.join(", ")
                              : "Not Applicable"
                          }     
                          </Typography>
                        </Grid>
                      </>
                    )}

                     {fullCandidateDetails?.[0]?.pgspecialsubject?.length > 0 && (
                        <>
                          <Grid
                            item
                            md={6}
                            xs={6}
                            sx={{ border: "1px solid #000", width: "50%" }}
                          >
                            <Typography
                              sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                              px={1}
                            >
                              Special Education Method/Subject
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            md={6}
                            xs={6}
                            sx={{ border: "1px solid #000", width: "50%" }}
                          >
                            <Typography
                              sx={{
                                fontSize: 10,
                                textAlign: "left",
                                color: "black",
                                fontWeight: "bold",
                              }}
                              px={1}
                            >
                              {fullCandidateDetails?.[0]?.pgspecialsubject?.[0] === 0 ? (
                                "Not Applicable"
                              ) : (
                                pgSpecialName?.all
                                  ?.filter((obj) =>
                                    fullCandidateDetails?.[0]?.pgspecialsubject?.includes(
                                      obj.pgspecializationid
                                    )
                                  )
                                  ?.map((val) => val.pgspecialization)
                                  ?.join(", ") || "Not Applicable"
                              )}
                            </Typography>
                          </Grid>
                        </>

                      )}

                    {fullCandidateDetails?.[0]?.pgotherdegreename && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Other Degree Name{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgotherdegreename}
                          </Typography>
                        </Grid>
                      </>
                    )}

                    {fullCandidateDetails?.[0]?.pgmarktype && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Marks Type{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                              {fullCandidateDetails?.[0]?.pgmarktype == 1 ? "Percentage" : fullCandidateDetails?.[0]?.pgmarktype == 2 ? "CGPA" : null}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgmarksobtained && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Marks / CGPA Obtained{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgmarksobtained}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgmarksoutof && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Maximum Marks / CGPA{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgmarksoutof}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgpercentage && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post Graduation Percentage{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgpercentage}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgawardedclassid && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Post graduation awarded class{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {/* {fullCandidateDetails?.[0]?.pgawardedclassid} */}
                            {
                            fullCandidateDetails?.[0]?.pgawardedclassid
                              ? pgawardedClassList?.all
                                ?.filter(state =>
                                  state?.awardedclassid === fullCandidateDetails?.[0]?.pgawardedclassid
                                )
                                ?.map(val => {
                                  return val?.awardedclass;
                                })
                                ?.join(", ")
                              : "Not Applicable"
                          }
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgduration && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Post Graduation Duration (in Years)`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgduration}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgcollegestateid && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            University State{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                                  {
                            fullCandidateDetails?.[0]?.pgcollegestateid
                              ? stateList?.all
                                ?.filter(state =>
                                  state?.stateid === fullCandidateDetails?.[0]?.pgcollegestateid
                                )
                                ?.map(val => {
                                  return val?.state;
                                })
                                ?.join(", ")
                              : "Not Applicable"
                          }  
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pguniversityname && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {/* Name of University{" "} */}
                            Name of University (Post Graduation)
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pguniversityname}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgotheruniversityname && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Other University Name{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgotheruniversityname}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgpassingdate && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Date of Passing Final Graduation`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {dayjs(fullCandidateDetails?.[0]?.pgpassingdate).format("DD/MM/YYYY")}
                          </Typography>
                        </Grid>
                      </>
                    )}

                    {fullCandidateDetails?.[0]?.ispgmh !== null  && fullCandidateDetails?.[0]?.graduationstatus !== 1 ? (
                      <>
                          <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Whether passed Graduation from Institution situated in
                            Maharashtra{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.ispgmh === 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                      </>
                    ) : null}




                    {fullCandidateDetails?.[0]?.pgpinterncompleteddate && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Internship Training Date of Completion / Likely to complete (Before 31/10/25)`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {dayjs(fullCandidateDetails?.[0]?.pgpinterncompleteddate).format("DD/MM/YYYY")}
                          </Typography>
                        </Grid>
                      </>
                    )}

                    {/* {fullCandidateDetails?.[0]?.graduationstatus === 2 ? (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Maharashtra OT/PT Council Registration for B.P.Th. / B.O.Th.`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgotpreg === 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                      </>
                    ) : null} */}
                    {fullCandidateDetails?.[0]?.graduationstatus === 2 && fullCandidateDetails?.[0]?.pgotpreg != 1  && fullCandidateDetails?.[0]?.appliedpgotptreg != null ? (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Have you applied for registration with Maharashtra State Occupational Therapy and Physiotherapy Council?
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.appliedpgotptreg === 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                      </>
                    ) : null}




                        {/* {fullCandidateDetails?.[0]?.graduationstatus === 2 ? (
                          <>
                          <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Rehabilitation Council of India Registration (for BASLP, B.Sc (Speech & Hearing), BPO, and B.Sc (P&O))`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgrcireg == 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                          </>
                        ) : null} */}
                    
                    {fullCandidateDetails?.[0]?.graduationstatus === 2 && fullCandidateDetails?.[0]?.pgotpreg != 1  && fullCandidateDetails?.[0]?.appliedpgotptreg != null ? (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Have you applied for registration with Maharashtra State Occupational Therapy and Physiotherapy Council?
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.appliedpgotptreg === 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                      </>
                    ) : null}



                    {fullCandidateDetails?.[0]?.pgrcireg == null ? null : (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Are you registered with Rehabilitation Council of India (RCI)?`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgrcireg == 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.graduationstatus === 2 && fullCandidateDetails?.[0]?.pgrcireg != 1 && fullCandidateDetails?.[0]?.appliedpgrcireg !=null ? (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`Have you applied for registration with the Rehabilitation Council of India?`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.appliedpgrcireg == 1
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </Grid>
                      </>
                    ) : null}



                    {fullCandidateDetails?.[0]?.councilregappno && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            CouncilRegAppNo{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.councilregappno}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.applicationdate && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            ApplicationDate{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {dayjs(fullCandidateDetails?.[0]?.applicationdate).format("DD/MM/YYYY")}
                          </Typography>
                        </Grid>
                      </>
                    )}


                    {fullCandidateDetails?.[0]?.isadmittedpg == null || fullCandidateDetails?.[0]?.isadmittedpg == undefined ? null : (
                      <>
                                              <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {`
If Already admitted and Pursuing P.G. Course M.P.Th./M.O.Th./M.S.L.P./MSc. (P & O)`}{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {/* {
                              YesOrNo.find(
                                (doc) =>
                                  doc.value ===
                                  fullCandidateDetails?.[0]?.isadmittedpg
                              )?.label
                            } */}

                            {
                     fullCandidateDetails?.[0]?.isadmittedpg === 1 ? "Yes" : "No"
                      }
                          </Typography>
                        </Grid>
                      </>
                    )}




                    {fullCandidateDetails?.[0]?.pgpedupreference1 && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Education Preference 1{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {
                             
                                  fullCandidateDetails?.[0]?.pgpedupreference1
                            }
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgpedupreference2 && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Education Preference 2{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {
                           
                                  fullCandidateDetails?.[0]?.pgpedupreference2
                            }
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgpedupreference3 && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Education Preference 3{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {
                            
                                  fullCandidateDetails?.[0]?.pgpedupreference3
                            }
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {fullCandidateDetails?.[0]?.pgpexamination && (
                      <>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            Examination
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.pgpexamination}
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </>
              )}
              

                            {(fullCandidateDetails?.[0]?.gengmediumcollege ||
                fullCandidateDetails?.[0]?.gengmediumcollege == 0) && (
                  <Grid container
                      md={12}
                      xs={12}
                      // px={1}
                      // sx={{ border: "1px solid #000", width: "100%" }}
                      >
                    <Grid
                      item
                      md={6}
                      xs={6}
                      px={1}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                        px={1}
                      >
                        {/* Do you want to apply for English Medium College of
                        Education? OR Do you want to complete your B. Ed. in
                        English Medium?{" "} */}
                        English medium Education{" "}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      xs={6}
                      // px={1}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        px={1}
                        sx={{
                          fontSize: 10,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.gengmediumcollege == 1
                          ? "Yes"
                          : "No"}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

              {fullCandidateDetails?.[0]?.geltc && (
                <Grid container md={12}
                    xs={12}>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      Appearing ELCT
                    </Typography>
                  </Grid>
                  <Grid item md={6} xs={6} sx={{ border: "1px solid #000", width: "50%" }}>
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.geltc == 1 ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {fullCandidateDetails?.[0]?.goptspecialedcollege && (
                <Grid container md={12}
                    xs={12}>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                      px={1}
                    >
                      {/* Do you want to Opt for Special Education Colleges?{" "} */}
                      Opt for Special Education Colleges
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                    // px={1}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      px={1}
                      sx={{
                        fontSize: 10,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.[0]?.goptspecialedcollege == 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </Grid>
              )}

                              {fullCandidateDetails?.[0]?.gspecialeducationmethod?.length > 0 && (
                  <Grid container md={12}
                    xs={12}>
                    <Grid
                      item
                      md={6}
                      xs={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{ fontSize: 10, textAlign: "right", color: "#000" }}
                        px={1}
                      >
                        Special Education Method/ Subject
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      md={6}
                      xs={6}
                      sx={{ border: "1px solid #000", width: "50%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        px={1}
                      >
                          {
                            gspecialEdMethodSubjectList?.all
                              ?.filter(obj =>
                                fullCandidateDetails?.[0]?.gspecialeducationmethod?.includes(
                                  obj?.gspecialedmethodid
                                )
                              )
                              ?.map(val => {
                                return val?.gspecialedmethod;
                              })
                              ?.join(", ") || "Not Applicable"
                          }
                      </Typography>
                    </Grid>
                  </Grid>

                )}

          {(fullCandidateDetails?.[0]?.subjectgroup ||
            fullCandidateDetails?.[0]?.examstate ||
            fullCandidateDetails?.[0]?.languageid ||
            fullCandidateDetails?.[0]?.preference1district ||
            fullCandidateDetails?.[0]?.preference2district ||
            fullCandidateDetails?.[0]?.preference3district ||
            fullCandidateDetails?.[0]?.preference4district || fullCandidateDetails?.[0]?.isotbs == true) && (
            <>
              <Box
               sx={{
                      // border: "1px solid #000",
                      marginTop: ".1rem",
                      paddingX: 1,
                      width: "100%",
                      backgroundColor:"#c4c4c4"
                    }}
              >
                <Box>
                  <Typography  sx={{ fontSize: 12, fontWeight: "bold" }}>
                    Exam Center Selection Details
                  </Typography>
                </Box>
                
              </Box>
            </>
          )}
          {fullCandidateDetails?.[0]?.subjectgroup && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Subject Group for Exam
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 700,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.subjectgroup}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

           {fullCandidateDetails?.[0]?.noofattempts && (
                <>
                  <Grid container md={12}>
                    <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        Number of exam attempts
                      </Typography>
                    </Grid>
                    <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.noofattempts}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}

               {fullCandidateDetails?.[0]?.pcm_noofattempts && (
                <>
                  <Grid container md={12}>
                    <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        Number of exam PCM attempts
                      </Typography>
                    </Grid>
                    <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {/* {fullCandidateDetails?.[0]?.pcm_noofattempts} */}
                         {fullCandidateDetails?.[0]?.pcm_noofattempts == 1 ? "First Attempt" : fullCandidateDetails?.[0]?.pcm_noofattempts == 2 ? "Both Attempts" : null }
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.[0]?.pcb_noofattempts && (
                <>
                  <Grid container md={12}>
                    <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                      <Typography
                        sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                      >
                        Number of exam PCB attempts
                      </Typography>
                    </Grid>
                    <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "left",
                          color: "black",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {/* {fullCandidateDetails?.[0]?.pcb_noofattempts} */}
                          {fullCandidateDetails?.[0]?.pcb_noofattempts == 1 ? "First Attempt" : fullCandidateDetails?.[0]?.pcb_noofattempts == 2 ? "Both Attempts" : null }
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}

          {fullCandidateDetails?.[0]?.examstate && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Examination Center State
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.examstate}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.[0]?.languageid && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Language / Medium of the Question Paper
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  {/* {fullCandidateDetails?.[0]?.language?.map((val, i) => ( */}
                    <Typography
                     
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        fontWeight:"bold",
                        textAlign: "left",
                      }}
                    >
                       {Language.find(
                      (obj) => obj.value === fullCandidateDetails?.[0]?.languageid
                    )?.label || "Language not found"}
                    </Typography>
                  {/* ))} */}
                </Grid>
              </Grid>
            </>
          )}
<Grid container md={12}>
              <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "center",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  Preference No.
                </Typography>
              </Grid>

              <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "center",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  State
                </Typography>
              </Grid>
              <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "34%" }}>
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "center",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  District
                </Typography>
              </Grid>
            </Grid>
            {fullCandidateDetails?.[0]?.preference1state ? (
                <>
                  <Grid container md={12}>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {"1"}
                      </Typography>
                    </Grid>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.preference1state}
                      </Typography>
                    </Grid>


                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "34%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.preference1district}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              ) : fullCandidateDetails?.[0]?.isotbs == true && (fullCandidateDetails?.[0]?.venuestate !== null || fullCandidateDetails?.[0]?.venuestate !== undefined)  ? (
                <>
                  <>
                  <Grid container md={12}>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {"1"}
                      </Typography>
                    </Grid>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.venuestate}
                      </Typography>
                    </Grid>


                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "34%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.venuedistrict}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
                </>
              ) : null}
           

            {fullCandidateDetails?.[0]?.preference1state && (
                <>
                  <Grid container md={12}>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        2
                      </Typography>
                    </Grid>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.preference1state}
                      </Typography>
                    </Grid>

                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "34%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.preference2district}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}

            {fullCandidateDetails?.[0]?.preference1state && (
                <>
                  <Grid container md={12}>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        3{" "}
                      </Typography>
                    </Grid>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.preference1state}
                      </Typography>
                    </Grid>

                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "34%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.[0]?.preference3district}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}

            {fullCandidateDetails?.[0]?.preference1state && (
                <>
                  <Grid container md={12}>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        4{" "}
                      </Typography>
                    </Grid>
                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "33%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {(fullCandidateDetails?.[0]?.preference1state)}
                      </Typography>
                    </Grid>


                    <Grid item md={4} xs={4} sx={{ border: "1px solid #000", width: "34%" }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          px: 1,
                          textAlign: "center",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        {fullCandidateDetails?.length > 0 &&
                          (fullCandidateDetails?.[0]?.preference4district ||
                            "-----")}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}
          {/* {fullCandidateDetails?.[0]?.preference1district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 1
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.preference1district}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.[0]?.preference2district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 2
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.preference2district}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.[0]?.preference3district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 3
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.[0]?.preference3district}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.[0]?.preference4district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 10, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 4
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 10,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      fontWeight:"bold",
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.length > 0 &&
                      (fullCandidateDetails?.[0]?.preference4district || "-----")}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )} */}

          {/* <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Post Graduation Information</Typography>
            </Box>
          </Box> */}
          {/* <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Document For Type A
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Document Of
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                CET Exam Name
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Whether Pass Institution Situated MH?
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
             <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                PF Graduation Date
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Internship Training Date
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                MH Council Registration
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Re Council Registration
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
             <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Already Admitted
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
                      <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                College Name
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
                      <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                University Name
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
                      <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid> */}
          {/* <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>First Year Marks</Typography>
            </Box>
          </Box> */}
          {/* <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid> */}
          {/* <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Second Year Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                SY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                SY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                SY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                SY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid>
          <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Third Year Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                TY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                TY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                TY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                TY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid>
          <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Fourth Year Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FourY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FourY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FourY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                FourY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid>
          <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Aggregate Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Aggregate Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Aggregate Marks Out Of
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 10,
                px:1, textAlign: "left",  }}
              >
                Aggregate Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid> */}
        </Grid>

        {/* <Grid item md={12} xs={12}>
          <Box
            sx={{
              border: "1px solid #000",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>
                Photograph and Signature
              </Typography>
            </Box>
            {location.search !== "?page=printapplication" && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() =>
                  navigate(
                    `/${localStorage.getItem(
                      "mhet_cnd_project"
                    )}/registration?page=uploads`,
                    {
                      state: {
                        courseid: courseid,
                        coursename: coursename,
                        status: status >= 5 ? 1 : 0,
                      },
                    }
                  )
                }
              >
                <MdOutlineModeEdit size={20} /> &nbsp;
                <Typography sx={{ fontSize: 18 }}>Edit</Typography>
              </Box>
            )}
          </Box>
          <Grid container md={12}>
            <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "center",
                  color: "black",
                  fontWeight: 500,
                }}
              >
                Photograph
              </Typography>
            </Grid>
            <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                Signature
              </Typography>
            </Grid>
          </Grid>
          <Grid container md={12}>
            <Grid
              item
              md={6}
              xs={6}
              sx={{
                border: "1px solid #000",
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                style={{ height: "140px", width: "auto" }}
                src={fullCandidateDetails?.document}
                alt="photo"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
              sx={{
                border: "1px solid #000",
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                style={{ height: "53px", width: "auto" }}
                src={fullCandidateDetails?.document}
                alt="signatute"
              />
            </Grid>
          </Grid>
        </Grid>
*/}
        <Grid item md={12} xs={12}>
          <Grid
            container
            // md={12}
            // xs={12}

           sx={{
                display: "flex",
                // justifyContent: "space-between",
                paddingX: 1,
                width: "100%",
                backgroundColor:"#c4c4c4"
                
              }}
          >
            <Box>
              <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>Document Uploaded</Typography>
            </Box>
          </Grid>
          <Grid container md={12}>
            <Grid item md={2} xs={2} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 10,
                  px: 1,
                  textAlign: "center",

                  fontWeight: 500,
                }}
              >
                S.No
              </Typography>
            </Grid>
            <Grid item md={10} xs={10} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 10,
                  px: 1,
                  textAlign: "left",

                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                Document Name
              </Typography>
            </Grid>
          </Grid>
          <Grid container md={12}>
            <Grid item md={2} xs={2} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 10,
                  px: 1,
                  textAlign: "center",
                  color: "black",
                  fontWeight: 500,
                }}
              >
                1
              </Typography>
            </Grid>
            <Grid item md={10} xs={10} sx={{ border: "1px solid #000" }}>
            {uploadDetails.length > 2 && uploadDetails[2]?.documentname && (
                <Typography
                  sx={{
                    fontSize: 10,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {uploadDetails[2]?.documentname}
                </Typography>
              )}
            </Grid>
            {/* <Grid
              item
              md={6}
              xs={6}
              sx={{
                border: "1px solid #000",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                component="a"
                sx={{
                  fontSize: 10,
                  px:1,
                  textAlign: "left",

                  fontWeight: 500,
                  textAlign: "center",
                  cursor: "pointer",
                  ":hover": {
                    textDecoration: "underline",
                  },
                }}
                target="_blank"
                href={pdfUrl}
              >
                View
              </Box>
            </Grid> */}
          </Grid>
        </Grid>

              {!(["149", "134"]?.includes(String(courseid || localStorage.getItem("courseid")))) ? (
                <>
                  <Grid item md={12} xs={12} sx={{ border: "1px solid #000" }}>
                    <Box
                      sx={{
                        width: "100%",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <Box
                        sx={{

                          width: "100%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 12,
                            px: 1,
                            textAlign: "left",
                            color: "black",
                            fontWeight: "bold",
                            textAlign: "left",
                            borderBottom: "1px solid #000",
                          }}
                        >
                          Declaration of the Candidate:
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            px: 1,
                            textAlign: "left",
                            color: "black",
                            fontWeight: 500,
                            textAlign: "left",
                          }}
                        >
                          {/* I {fullCandidateDetails?.[0]?.candidatename} have downloaded
                      the Information Brochure of {coursename} and have read all
                      the rules for appearing the CET and on understanding these
                      Rules, I have filled this Application Form for appearing
                      to {coursename} for the Academic Year 2024-25. This
                      information given by me in this application is true to the
                      best of my knowledge & belief. If at later stage, it is
                      found that I have furnished wrong informatation and/or
                      submitted false certificate(s), I am aware that my
                      admission stands cancelled and fees paid by me will be
                      forfeited. Further I will be subject to legal and/or penal
                      action as per the provisions of the law. */}
                          <ol style={{ fontSize: 12, fontWeight: "bold", marginLeft: "-5px" }}>
                            <li style={{ fontWeight: 500 }}>
                              I hereby solemnly and sincerely affirm that each and every statement made and the entire information given by me in the application form is true and correct.
                            </li>
                            <li style={{ fontWeight: 500 }}>
                              I have not concealed any material information, however if any information submitted herein is found fraudulent, incorrect or untrue, I understand that I am liable to criminal persecution and I also agree to forgo my seat in Medical Postgraduate course. I also understand that my selection and admission to the course is also liable to be cancelled.
                            </li>
                            <li style={{ fontWeight: 500 }}>
                              {`I have carefully read the rules & regulations of ${fullCandidateDetails?.[0]?.coursename} brochure and I agree to abide by them. Hereby accept in entire the legality, validity and correctness of these rules. I understand by submitting this application I have accepted the correctness, validity and/ or justifiability of all these and that had I not accepted the correctness and validity of these rules, I would not have submitted this application and further that it will not be open hereinafter to challenge and/or question validity and/ or correctness of any rule or part thereof.`}
                            </li>
                            <li style={{ fontWeight: 500 }}>
                              I undertake to submit all the required original certificates at the time of uploading of document / physical Document verification process as well as at the time of admission to a course/college as per the rules, failing which I understand that my claim for selection shall not be granted.
                            </li>

                          </ol>
                          {/* <span style={{ fontSize: 11, fontWeight: "bold", marginTop: "10px" }}>I agree to aforesaid conditions.</span> */}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography px={1} sx={{ fontSize: 12, color: "red", fontWeight: 600 }}>
                          Note :
                        </Typography>
                        <List

                          sx={{
                            listStyleType: "disc",
                            fontSize: 12,
                            color: "#e6393f",
                            paddingLeft: "20px",
                            m: 0,
                          }}
                        >
                          <ListItem sx={{
                            display: "list-item", m: 0,      // margin vertical between items
                            p: 0
                          }}>
                            {/* Candidate to note the districts given in the options
                          may not be available necessarily. If the
                          Infrastructure is not available for conducting
                          computer based Test in the First District. In such a
                          case, the candidate will be shifted to the district of
                          the next choice, and the allotted district will be
                          mentioned in the Admit Card */}
                            You are required to Upload the Caste Certificate clearly mentioning the Category of the Candidate
                            and also the remarks that the Caste is recognised as backward class in the State of Maharastra at the time of Centralised Admission Process (CAP 2026).
                          </ListItem>

                          <ListItem sx={{
                            display: "list-item", m: "0px",        // margin vertical between items
                            p: 0
                          }}>
                            You are required to Upload the Caste / Tribe Validity Certificate in the name of the Candidate, issued by the caste validity committee of Maharashtra State at the time of Centralised Admission Process (CAP 2026).
                          </ListItem>

                          <ListItem sx={{
                            display: "list-item", m: "0px",        // margin vertical between items
                            p: 0
                          }}>
                            You are required to Upload Non-Creamy Layer Certificate issued by Sub Divisional officer or Deputy Collector of the district in addition to the caste certificate valid upto 31/03/2027 or Later at the time of Centralised Admission Process (CAP 2026).
                          </ListItem>
                        </List>
                      </Box>
                    </Box>
                    <Grid container sx={{ width: "100%" }}>
                      <Grid item md={8} xs={8}>
                        <Box
                          sx={{
                            border: "1px solid #000",

                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: 500,
                              textAlign: "left",
                            }}
                          >
                            Date :{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {dayjs().format("DD/MM/YYYY")}
                            </span>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            border: "1px solid #000",

                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: 500,
                              textAlign: "left",
                            }}
                          >
                            Last Modified By :{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {fullCandidateDetails?.[0]?.applicantId ? fullCandidateDetails?.[0]?.applicantId + " " + fullCandidateDetails?.[0]?.ipaddress : fullCandidateDetails?.[0]?.ipaddress}
                            </span>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            border: "1px solid #000",

                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: 500,
                              textAlign: "left",
                            }}
                          >
                            Last Modified On :
                            <span style={{ fontWeight: "bold" }}>
                              {dayjs(fullCandidateDetails?.[0]?.updateddate).format("DD/MM/YYYY hh:mm:ss A")}
                            </span>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            border: "1px solid #000",

                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: 500,
                              textAlign: "left",
                            }}
                          >
                            Printed On :{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {fullCandidateDetails?.[0]?.printtimestamp ? dayjs(fullCandidateDetails?.[0]?.printtimestamp).format("DD/MM/YYYY hh:mm:ss A") : "-"}
                            </span>
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} xs={4}>
                        <Box
                          sx={{
                            border: "1px solid #000",
                            display: "grid",
                            placeItems: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          {signature && (
                            <img
                              style={{
                                width: "180px",
                                height: "70px",
                              }}
                              src={signature?.fileurl}
                              alt="Signature"
                            />
                          )}
                          <Typography style={{ fontSize: 10 }}>Signature of Applicant</Typography>
                          <Typography style={{ fontSize: 10, fontWeight: "bold" }}> {fullCandidateDetails?.[0]?.candidatename || "-"}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : null}


      </Grid>
    </Box>

    
                            {(fullCandidateDetails?.[0]?.isdisability == 1 && fullCandidateDetails?.[0]?.isscribe == 1)
                  && fullCandidateScribeDetails?.length > 0 ? (
                  <Grid container
                    sx={{
                      '@media print': {
                        pageBreakBefore: 'always',
                      },
                    }}
                    style={{
                      minHeight: "50vh",
                      marginTop: 5,
                      width: "100%",
                      marginBottom: 10,
                      border:"1px solid black"
                    }}>
                    <Box
                      style={{
                        borderBottom: "1px solid black",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "left",
                        width: "100%",
                        height: 30
                      }}
                    >

                          <Typography
                            fontWeight={600}
                            sx={{
                              marginLeft: "5px", textAlign: "left", width: "100%", fontSize: 15
                            }}
                          >
                            {/* Online Registration For {coursename || coursenameVal} */}
                            Scribe Information of application Form for Online Registration For {fullCandidateDetails?.[0]?. coursename || localStorage.getItem("coursename")}
                          </Typography>
                        <Typography fontWeight={600} sx={{ textWrap: "nowrap", fontSize: 15, marginRight: "10px" }}>
                          Application Form
                        </Typography>
                    </Box>

                    <Grid
                      container
                      //   p={3}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderBottom: "1px solid #000",
                      }}
                    >
                      <Grid item pl={1} sx={{ width: "100px" }}>
                        <img
                          style={{ height: "70px", width: "auto" }}
                          src={CetImage}
                          alt="image"
                        />
                      </Grid>
                      <Grid
                        item
                        // md={8}

                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          flex: 1,
                        }}
                      >
                        <img
                          style={{ height: "75px", width: "auto" }}
                          src={GovernmentImage}
                          alt="image"
                        />
                        <Typography variant="h5" fontWeight={600}>
                          GOVERNMENT OF MAHARASHTRA
                        </Typography>
                        <Typography variant="h5" fontWeight={600}>
                          STATE COMMON ENTRANCE TEST CELL, MAHARASHTRA STATE
                        </Typography>
                        <Typography variant="p" fontWeight={600}>
                          8th Floor, New Excelsior Building, A.K.Nayak Marg, Fort,
                          Mumbai-400001. (M.S.)
                        </Typography>
                        <Typography variant="p" sx={{ marginTop: 1 }} fontWeight={600}>
                          Application Form for Online Registration For{" "}
                          {fullCandidateDetails?.[0]?.coursename || localStorage.getItem("coursename")}
                        </Typography>
                        {/* <Typography>APPLICATION FORM</Typography> */}
                      </Grid>
                      <Grid
                        item
                        pr={1}
                        sx={{ display: "flex", justifyContent: "flex-end", width: "100px" }}
                      >
                        <img
                          style={{ height: "70px", width: "auto" }}
                          src={Ara}
                          alt="image"
                        />
                      </Grid>
                    </Grid>
                    <Box sx={{ borderBottom: "1px solid #000", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <Typography
                            variant="h6"
                            sx={{
                              textWrap: "wrap",
                              // fontWeight: "bold",
                              color: "#000",
                              textAlign: "center",
                            }}
                          >
                            Application No :  <span style={{ fontWeight: "bold" }}>{fullCandidateDetails?.[0]?.applicantId}</span> {"  "}
                            <span style={{ marginLeft: "20px" }}>Version No : <span style={{ fontWeight: "bold" }}>{fullCandidateDetails?.[0]?.versionno}</span></span>
                          </Typography>
                    </Box>

                    <Grid item xs={12}>
                      <Box sx={{
                        borderBottom: "1px solid #000",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingX: 1,
                        backgroundColor: "#c4c4c4"
                      }}>
                        <Box
                          sx={{
                            display: "flex",

                          }}
                        >
                          <Box>
                            <Typography variant="p" sx={{ fontSize: 12, fontWeight: "bold" }}>
                              Candidate Information
                            </Typography>
                          </Box>

                          {/* {" "}   {location.search.split("&&")[0] !== "?page=printapplication" &&
                !edit &&
                !print && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "#3F41D1",
                      marginLeft:"10px"
                    }}
                    onClick={() =>{
                          dispatch({
                            type: candidatesActions.GET_COURSE_FORM_DETAILS,
                            payload: { courseid: parseInt(courseid) },
                          });
                            dispatch({
                              type: candidatesActions.GET_COURSE_REGISTRATION_DETAILS,
                              payload: {
                                courseid: parseInt(courseid),
                              },
                            });
                          navigate(
                        `/${localStorage.getItem(
                          "mhet_cnd_project"
                        )}/course-registration?page=personalinformation&courseid=${EncryptFunction(
                          courseid
                        )}&coursename=${encodeURIComponent(coursename)}`,
                        {
                          state: {
                            courseid: courseid,
                            coursename: coursename,
                            status: status >= 5 ? 1 : 0,
                          },
                        }
                      )
                    }

                    }
                  >
                    <MdOutlineModeEdit size={20} /> &nbsp;
                    <Typography sx={{ fontSize: 12,fontWeight:"bold" }}>Edit</Typography>
                  </Box>
                )} */}
                        </Box>

                        {/* {location.search.split("&&")[0] !== "?page=printapplication" &&
                !edit &&
                !print && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "#3F41D1",
                    }}
                    onClick={() =>
                      navigate(
                        `/${localStorage.getItem(
                          "mhet_cnd_project"
                        )}/registration?page=uploads`,
                        {
                          state: {
                            courseid: courseid,
                            coursename: coursename,
                            status: status >= 5 ? 1 : 0,
                            fromPreview: true,
                          },
                        }
                      )
                    }
                  >
                    <MdOutlineModeEdit size={20} /> &nbsp;
                    <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>Edit</Typography>
                  </Box>
                )} */}
                      </Box>

                      <Grid container xs={12} >
                        <Grid item md={10} sx={{ width: "80%" }}>
                          <Grid container xs={12}>
                            <Grid
                              item
                              md={7}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                              >
                                {" "}
                                Candidate Full Name
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              md={5}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 10,
                                  px: 1,
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                {fullCandidateDetails?.[0]?.candidatename}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              md={7}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                              >
                                {" "}
                                UDID No.
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              md={5}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 10,
                                  px: 1,
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                {fullCandidateDetails?.[0]?.udidnumber}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              md={7}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                              >
                                {" "}
                                Candidate's Name (as per  HSC / Engineering Diploma / SSC marksheet)
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              md={5}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 10,
                                  px: 1,
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                {fullCandidateDetails?.[0]?.name_as_per_hsc}
                              </Typography>
                            </Grid>



                            {/* <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                    >
                      		Candidate's Name (as per  HSC / Engineering Diploma/ SSC marksheet)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sx={{ border: "1px solid #000", width: "50%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 10,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails[0]?.name_as_per_hsc}
                    </Typography>
                  </Grid> */}


                            <Grid
                              item
                              md={7}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                              >
                                {" "}
                                Candidate Contact
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              md={5}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 10,
                                  px: 1,
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                {fullCandidateDetails?.[0]?.mobileno}
                              </Typography>
                            </Grid>

                            {fullCandidateDetails?.[0]?.isdisability && (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Are you person with disability
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {parseInt(fullCandidateDetails?.[0]?.isdisability) == 1
                                      ? "Yes"
                                      : parseInt(fullCandidateDetails?.[0]?.isdisability) == 0
                                        ? "No"
                                        : "---"}
                                  </Typography>
                                </Grid>
                              </>
                            )}

                            {fullCandidateDetails?.[0]?.pwdtype &&
                              fullCandidateDetails?.[0]?.isdisability != 0 && (
                                <>
                                  <Grid
                                    item
                                    md={7}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                    >
                                      {" "}
                                      Type Of Disability
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    md={5}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        px: 1,
                                        textAlign: "left",
                                        color: "black",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {fullCandidateDetails?.[0]?.pwdtype}
                                    </Typography>
                                  </Grid>
                                </>
                              )}

                            {fullCandidateDetails?.[0]?.pwdsubtype &&
                              fullCandidateDetails?.[0]?.isdisability != 0 && (
                                <>
                                  <Grid
                                    item
                                    md={7}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                    >
                                      {" "}
                                      PWD Sub Type
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    md={5}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        px: 1,
                                        textAlign: "left",
                                        color: "black",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {fullCandidateDetails?.[0]?.pwdsubtype}
                                    </Typography>
                                  </Grid>
                                </>
                              )}

                            {fullCandidateDetails?.[0]?.isextratime &&
                              fullCandidateDetails?.[0]?.isdisability != 0 && (
                                <>
                                  <Grid
                                    item
                                    md={7}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                    >
                                      {" "}
                                      Require Extra Time
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    md={5}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        px: 1,
                                        textAlign: "left",
                                        color: "black",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {parseInt(fullCandidateDetails?.[0]?.isextratime) == 1
                                        ? "Yes"
                                        : parseInt(fullCandidateDetails?.[0]?.isextratime) == 0
                                          ? "No"
                                          : "----"}
                                    </Typography>
                                  </Grid>
                                </>
                              )}

                            {fullCandidateDetails?.[0]?.isscribe &&
                              fullCandidateDetails?.[0]?.isdisability != 0 && (
                                <>
                                  <Grid
                                    item
                                    md={7}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                    >
                                      {" "}
                                      Require Scribe
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    md={5}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        px: 1,
                                        textAlign: "left",
                                        color: "black",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {parseInt(fullCandidateDetails?.[0]?.isscribe) == 1
                                        ? "Yes"
                                        : parseInt(fullCandidateDetails?.[0]?.isscribe) == 0
                                          ? "No"
                                          : "----"}
                                    </Typography>
                                  </Grid>
                                </>
                              )}



                            {/* {isPwdAllowed && fullCandidateDetails[0]?.isscribe === "1" ? ( */}
                            {/* {fullCandidateDetails?.[0]?.isscribe === "1" ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Candidate Appendix 1 & 2 document
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%", position: "relative" }}
                                >
                                  <Typography
                                    component="a"
                                    href={uploadDetails?.find((item) => item?.documenttype == 5)?.fileurl}
                                    target="_blank"
                                    sx={{
                                      fontSize: 10,
                                      // px: 1,
                                      color: "blue",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                      marginLeft: 1,
                                      marginBottom: 2,
                                      position: "absolute",
                                      top: 0
                                    }}
                                  >
                                    View Document
                                  </Typography>
                                </Grid>
                              </>
                            ) : null} */}






                            {/* <Grid
                              item
                              md={7}
                              sx={{ border: "1px solid #000", width: "50%" }}
                            >
                              <Typography
                                sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                              >
                                {" "}
                                Candidate UDID / Disability Certificate
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              md={5}
                              sx={{ border: "1px solid #000", width: "50%", position: "relative" }}
                            >
                              <Typography
                                component="a"
                                href={uploadDetails?.find((item) => item?.documenttype == 4)?.fileurl}
                                target="_blank"
                                sx={{
                                  fontSize: 10,
                                  // px: 1,
                                  color: "blue",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  marginLeft: 1,
                                  marginBottom: 2,
                                  position: "absolute",
                                  top: 0
                                }}
                              >
                                View Document
                              </Typography>
                            </Grid> */}

                                <>
                                  {" "}
                                  <Grid
                                    item
                                    md={7}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                    >
                                      {" "}
                                      {fullCandidateDetails?.[0]?.coursename} Application Fee Paid
                                      (&#x20B9;)
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    md={5}
                                    sx={{ border: "1px solid #000", width: "50%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        px: 1,
                                        textAlign: "left",
                                        color: "black",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {/* {fullCandidateDetails?.[0]?.amount} /- */}
                                            {fullCandidateDetails?.reduce(
                                              (sum, x) => sum + Number(x?.amount),
                                              0
                                            )} /-
                                    </Typography>
                                  </Grid>
                                </>
                            
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          md={2}
                          sx={{ border: "1px solid #000", width: "20%" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                borderBottom: "3px solid #000",
                                // paddingBottom: "8px",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              {/* {fileUrl && showImage && ( */}
                              <>
                                <img
                                  style={{
                                    width: "100%",
                                    height: "140px",
                                    // aspectRatio: "4 / 3",
                                    // display: isImageLoaded ? "block" : "none",
                                  }}
                                  src={fileUrl}
                                  alt="signature"
                                />
                              </>
                              {/* )} */}
                            </Box>

                            <Box
                              sx={{
                                // paddingTop: "10px",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              {/* {fileUrl2 && showImage && ( */}
                              <>
                                <img
                                  style={{ width: "100%", height: "75px" }}
                                  src={uploadDetails?.find(
                                        (item) => item?.documenttype == 2
                                      )?.fileurl
                                  }
                                  alt="signature"
                                // onLoad={() => setIsImageLoaded(true)}
                                />
                              </>
                              {/* )} */}
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>


                    <Grid item xs={12}>
                      <Box sx={{
                        borderBottom: "1px solid #000",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingX: 1,
                        backgroundColor: "#c4c4c4"
                      }}>
                        <Box
                          sx={{
                            display: "flex",

                          }}
                        >
                          <Box>
                            <Typography variant="p" sx={{ fontSize: 12, fontWeight: "bold" }}>
                              Scribe 1 Information
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Grid container xs={12} >
                        <Grid item md={10} sx={{ width: "80%" }}>
                          <Grid container xs={12}>
                            {scribe1Details?.scribename ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 1 Full Name
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {scribe1Details?.scribename}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}

                            {scribe1Details?.scribemobile ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 1 Contact
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {scribe1Details?.scribemobile}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}

                            {scribe1Details?.scribedob ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 1 DOB
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {/* {scribe1Details?.scribedob} */}
                                    {dayjs(scribe1Details?.scribedob).format("DD/MM/YYYY")}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}


                            {scribe1Details?.scribeaadhaar ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 1 Masked Aadhaar
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {scribe1Details?.scribeaadhaar}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}












                          </Grid>
                        </Grid>

                        {/* {scribe1PhotoDetails?.signedUrl ? (
                          <>
                            <Grid
                              item
                              md={2}
                              sx={{ border: "1px solid #000", width: "20%" }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                }}
                              >
                                <Box
                                  sx={{
                                    borderBottom: "3px solid #000",
                                    width: "100%",
                                    textAlign: "center",
                                  }}
                                >
                                  <>
                                    <img
                                      style={{
                                        width: "100%",
                                        height: "140px",
                                      }}
                                      src={scribe1PhotoDetails?.signedUrl}
                                      alt="Scribe1Photo"
                                    />
                                  </>
                                </Box>
                              </Box>
                            </Grid>
                          </>
                         ) : null}  */}
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Box sx={{
                        borderBottom: "1px solid #000",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingX: 1,
                        backgroundColor: "#c4c4c4"
                      }}>
                        <Box
                          sx={{
                            display: "flex",

                          }}
                        >
                          <Box>
                            <Typography variant="p" sx={{ fontSize: 12, fontWeight: "bold" }}>
                              Scribe 2 Information
                            </Typography>
                          </Box>

                          {/* {" "}   {location.search.split("&&")[0] !== "?page=printapplication" &&
                !edit &&
                !print && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "#3F41D1",
                      marginLeft:"10px"
                    }}
                    onClick={() =>{
                          dispatch({
                            type: candidatesActions.GET_COURSE_FORM_DETAILS,
                            payload: { courseid: parseInt(courseid) },
                          });
                            dispatch({
                              type: candidatesActions.GET_COURSE_REGISTRATION_DETAILS,
                              payload: {
                                courseid: parseInt(courseid),
                              },
                            });
                          navigate(
                        `/${localStorage.getItem(
                          "mhet_cnd_project"
                        )}/course-registration?page=personalinformation&courseid=${EncryptFunction(
                          courseid
                        )}&coursename=${encodeURIComponent(coursename)}`,
                        {
                          state: {
                            courseid: courseid,
                            coursename: coursename,
                            status: status >= 5 ? 1 : 0,
                          },
                        }
                      )
                    }

                    }
                  >
                    <MdOutlineModeEdit size={20} /> &nbsp;
                    <Typography sx={{ fontSize: 12,fontWeight:"bold" }}>Edit</Typography>
                  </Box>
                )} */}
                        </Box>

                        {/* {location.search.split("&&")[0] !== "?page=printapplication" &&
                !edit &&
                !print && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "#3F41D1",
                    }}
                    onClick={() =>
                      navigate(
                        `/${localStorage.getItem(
                          "mhet_cnd_project"
                        )}/registration?page=uploads`,
                        {
                          state: {
                            courseid: courseid,
                            coursename: coursename,
                            status: status >= 5 ? 1 : 0,
                            fromPreview: true,
                          },
                        }
                      )
                    }
                  >
                    <MdOutlineModeEdit size={20} /> &nbsp;
                    <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>Edit</Typography>
                  </Box>
                )} */}
                      </Box>

                      <Grid container xs={12} >
                        <Grid item md={10} sx={{ width: "80%" }}>
                          <Grid container xs={12}>

                            {scribe2Details?.scribename ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 2 Full Name
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {scribe2Details?.scribename}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}

                            {scribe2Details?.scribemobile ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 2 Contact
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {scribe2Details?.scribemobile}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}

                            {scribe2Details?.scribedob ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 2 DOB
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {/* {scribe2Details?.scribedob} */}
                                    {dayjs(scribe2Details?.scribedob).format("DD/MM/YYYY")}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}

                            {scribe2Details?.scribeaadhaar ? (
                              <>
                                <Grid
                                  item
                                  md={7}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                  >
                                    {" "}
                                    Scribe 2 Masked Aadhaar
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={5}
                                  sx={{ border: "1px solid #000", width: "50%" }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 10,
                                      px: 1,
                                      textAlign: "left",
                                      color: "black",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    }}
                                  >
                                    {scribe2Details?.scribeaadhaar}
                                  </Typography>
                                </Grid>
                              </>
                            ) : null}



                            {/* <Grid
                                            item
                                            md={7}
                                            sx={{ border: "1px solid #000", width: "50%", }}
                                          >
                                            <Typography
                                              sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                                            >
                                              {" "}
                                              Scribe 2 Performa
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            md={5}
                                            sx={{ border: "1px solid #000", width: "50%", position: "relative" }}
                                          >
                                            <Typography
                                              onClick={handleCallScribe2DocDetails}
                                              sx={{
                                            fontSize: 10,
                                            // px: 1,
                                            color: "blue",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            marginLeft: 1,
                                            marginBottom: 2,
                                            position: "absolute",
                                            top: 0
                                              }}
                                            >
                                              View Document
                                            </Typography>
                                          </Grid> */}











                            {/* {location.pathname + location.search.split("&&")[0] ===
                    "/mhcet/course-registration?page=printapplication" && (
                      <>
                        {" "}
                        <Grid
                          item
                          md={7}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{ fontSize: 10, px: 1, textAlign: "right" }}
                          >
                            {" "}
                            {coursename || coursenameVal} Application Fee Paid
                            (&#x20B9;)
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          md={5}
                          sx={{ border: "1px solid #000", width: "50%" }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              px: 1,
                              textAlign: "left",
                              color: "black",
                              fontWeight: "bold",
                              textAlign: "left",
                            }}
                          >
                            {fullCandidateDetails?.[0]?.amount} /-
                          </Typography>
                        </Grid>
                      </>
                    )} */}
                          </Grid>
                        </Grid>


                      </Grid>
                    </Grid>

                    {(location.pathname + location.search.split("&")[0] ===
                      "/mhcet/course-registration?page=preview") && (
                        <>
                          <Box
                            sx={{
                              width: "100%",
                              borderBottom: "1px solid #000",
                            }}
                          >
                            <Box
                              sx={{

                                width: "100%",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  px: 1,
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  borderBottom: "1px solid #000",
                                  borderTop: "1px solid #000",
                                }}
                              >
                                Declaration of the Candidate:
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  px: 1,
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: 500,
                                  textAlign: "left",
                                }}
                              >
                                {/* I {fullCandidateDetails?.[0]?.candidatename} have downloaded
                      the Information Brochure of {coursename} and have read all
                      the rules for appearing the CET and on understanding these
                      Rules, I have filled this Application Form for appearing
                      to {coursename} for the Academic Year 2024-25. This
                      information given by me in this application is true to the
                      best of my knowledge & belief. If at later stage, it is
                      found that I have furnished wrong informatation and/or
                      submitted false certificate(s), I am aware that my
                      admission stands cancelled and fees paid by me will be
                      forfeited. Further I will be subject to legal and/or penal
                      action as per the provisions of the law. */}
                                {/* <ol style={{ fontSize: 12, fontWeight: "bold", marginLeft: "-5px" }}>
                            <li style={{ fontWeight: 500 }}>
                              I hereby solemnly and sincerely affirm that each and every statement made and the entire information given by me in the application form is true and correct.
                            </li>
                            <li style={{ fontWeight: 500 }}>
                              I have not concealed any material information, however if any information submitted herein is found fraudulent, incorrect or untrue, I understand that I am liable to criminal prosecution and I also agree to forgo my seat in Medical Postgraduate course. I also understand that my selection and admission to the course is also liable to be cancelled.
                            </li>
                            <li style={{ fontWeight: 500 }}>
                              {`I have carefully read the rules & regulations of ${courseName} brochure and I agree to abide by them. Hereby accept in entire the legality, validity and correctness of these rules. I understand by submitting this application I have accepted the correctness, validity and/ or justifiability of all these and that had I not accepted the correctness and validity of these rules, I would not have submitted this application and further that it will not be open hereinafter to challenge and/or question validity and/ or correctness of any rule or part thereof.`}
                            </li>
                            <li style={{ fontWeight: 500 }}>
                              I undertake to submit all the required original certificates at the time of uploading of document / physical Document verification process as well as at the time of admission to a course/college as per the rules, failing which I understand that my claim for selection shall not be granted.
                            </li>
                           
                          </ol> */}
                                I hereby declare that all the details provided by me in this application, including my PWD information and the particulars of the scribes (if applicable), are true, complete, and correct to the best of my knowledge and belief. I understand that if any discrepancy, misrepresentation, or incorrect information is found at any stage, I shall be solely responsible for the same, and my PWD status shall stand cancelled, making me ineligible for PWD-related provisions.
                              </Typography>
                            </Box>
                          </Box>
                          {/* {
                      <Grid
                        item
                        md={12}
                        py={1}
                        xs={12}
                        sx={{
                          border: "1px solid #F7F7F7",
                          borderRadius: "0px 0px 8px 8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "8px",
                            justifyContent: "space-between",
                            paddingX: 1,
                            alignItems:"flex-start"
                          }}
                        >
                          {!print && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1,
                              }}
                            >
                              <Checkbox
                                onChange={handleCheckbox}
                                checked={CheckboxValue}
                                sx={{ margin: 0, padding: 0 }}
                              />
                              <Typography
                                sx={{
                                  fontSize: 13,
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: 500,
                                  lineHeight: 1.5,
                                }}
                              >
                                I confirm that I have read and understood the
                                application instructions and reviewed all details
                                provided. I acknowledge that no changes can be
                                made once the fee is paid.
                              </Typography>
                            </Box>
                          )}

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                              marginLeft:"auto",
                              minWidth:180
                            }}
                          >
                            <img
                              style={{
                                width: "120px",
                                height: "auto",
                                aspectRatio: "4/3",
                              }}
                              src={
                                courseUploadDetails?.length
                                  ? courseUploadDetails?.find(
                                    (item, index) => item?.documenttype == 2
                                  )?.fileurl
                                  : uploadDetails?.find(
                                    (item, index) => item?.documenttype == 2
                                  )?.fileurl
                              }
                              alt="signatute"
                            />
                            <Typography
                              sx={{
                                fontSize: 15,
                                textAlign: "left",
                                color: "red",
                                fontWeight: 500,
                                textAlign: "left",
                              }}
                            >
                              Signature of candidate
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    } */}
                          {/* {error && (
                      <small
                        style={{
                          marginTop: "-3.5rem",
                          marginLeft: "22px",
                          fontSize: "14px",
                        }}
                        className="error"
                      >
                     {!print ? error : ""}
                      </small>
                    )} */}
                        </>
                      )}

                    {["149", "134"]?.includes(String(courseid || localStorage.getItem("courseid"))) ? (
                        <Grid item md={12} xs={12} sx={{ border: "1px solid #000" }}>
                          <Box
                            sx={{
                              width: "100%",
                              borderBottom: "1px solid #000",
                            }}
                          >
                            <Box
                              sx={{

                                width: "100%",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  px: 1,
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                  borderBottom: "1px solid #000",
                                }}
                              >
                                Declaration of the Candidate:
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  px: 1,
                                  textAlign: "left",
                                  color: "black",
                                  fontWeight: 500,
                                  textAlign: "left",
                                }}
                              >
                                {/* I {fullCandidateDetails?.[0]?.candidatename} have downloaded
                      the Information Brochure of {coursename} and have read all
                      the rules for appearing the CET and on understanding these
                      Rules, I have filled this Application Form for appearing
                      to {coursename} for the Academic Year 2024-25. This
                      information given by me in this application is true to the
                      best of my knowledge & belief. If at later stage, it is
                      found that I have furnished wrong informatation and/or
                      submitted false certificate(s), I am aware that my
                      admission stands cancelled and fees paid by me will be
                      forfeited. Further I will be subject to legal and/or penal
                      action as per the provisions of the law. */}
                                I hereby declare that all the details provided by me in this application, including my PWD information and the particulars of the scribes (if applicable), are true, complete, and correct to the best of my knowledge and belief. I understand that if any discrepancy, misrepresentation, or incorrect information is found at any stage, I shall be solely responsible for the same, and my PWD status shall stand cancelled, making me ineligible for PWD-related provisions.
                                <span style={{ fontSize: 11, fontWeight: "bold", marginTop: "10px" }}>I agree to aforesaid conditions.</span>
                              </Typography>
                            </Box>
                            <Box>
                              <Typography px={1} sx={{ fontSize: 12, color: "red", fontWeight: 600 }}>
                                Note :
                              </Typography>
                              <List

                                sx={{
                                  listStyleType: "disc",
                                  fontSize: 12,
                                  color: "#e6393f",
                                  paddingLeft: "20px",
                                  m: 0,
                                }}
                              >
                                <ListItem sx={{
                                  display: "list-item", m: 0,      // margin vertical between items
                                  p: 0
                                }}>
                                  {/* Candidate to note the districts given in the options
                          may not be available necessarily. If the
                          Infrastructure is not available for conducting
                          computer based Test in the First District. In such a
                          case, the candidate will be shifted to the district of
                          the next choice, and the allotted district will be
                          mentioned in the Admit Card */}
                                  You are required to Upload the Caste Certificate clearly mentioning the Category of the Candidate
                                  and also the remarks that the Caste is recognised as backward class in the State of Maharashtra at the time of Centralised Admission Process (CAP 2026).
                                </ListItem>

                                <ListItem sx={{
                                  display: "list-item", m: "0px",        // margin vertical between items
                                  p: 0
                                }}>
                                  You are required to Upload the Caste / Tribe Validity Certificate in the name of the Candidate, issued by the caste validity committee of Maharashtra State at the time of Centralised Admission Process (CAP 2026).
                                </ListItem>

                                <ListItem sx={{
                                  display: "list-item", m: "0px",        // margin vertical between items
                                  p: 0
                                }}>
                                  You are required to Upload Non-Creamy Layer Certificate issued by Sub Divisional officer or Deputy Collector of the district in addition to the caste certificate valid upto 31/03/2027 or Later at the time of Centralised Admission Process (CAP 2026).
                                </ListItem>
                              </List>
                            </Box>
                          </Box>

                          <Grid container sx={{ width: "100%" }}>
                            <Grid item md={12} xs={8} sx={{ width: "100%" }}>
                              <Box
                                sx={{
                                  border: "1px solid #000",

                                  width: "100%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 10,
                                    px: 1,
                                    textAlign: "left",
                                    color: "black",
                                    fontWeight: 500,
                                    textAlign: "left",
                                  }}
                                >
                                  Date :{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {dayjs().format("DD/MM/YYYY")}
                                  </span>
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  border: "1px solid #000",

                                  width: "100%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 10,
                                    px: 1,
                                    textAlign: "left",
                                    color: "black",
                                    fontWeight: 500,
                                    textAlign: "left",
                                  }}
                                >
                                  Last Modified By :{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    { fullCandidateDetails?.[0]?.ipaddress ? fullCandidateDetails?.[0]?.applicantId + " " + fullCandidateDetails?.[0]?.ipaddress : fullCandidateDetails?.[0]?.applicantId}
                                  </span>
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  border: "1px solid #000",

                                  width: "100%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 10,
                                    px: 1,
                                    textAlign: "left",
                                    color: "black",
                                    fontWeight: 500,
                                    textAlign: "left",
                                  }}
                                >
                                  Last Modified On :{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {dayjs(fullCandidateDetails?.[0]?.updateddate).format("DD/MM/YYYY hh:mm:ss A")} {"IST"}
                                  </span>
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  border: "1px solid #000",

                                  width: "100%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 10,
                                    px: 1,
                                    textAlign: "left",
                                    color: "black",
                                    fontWeight: 500,
                                    textAlign: "left",
                                  }}
                                >
                                  Printed On :{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {dayjs().format("DD/MM/YYYY hh:mm:ss A")} {"IST"}
                                  </span>
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : null}


                  </Grid>
                ) : null}
    </div>

    
    </Box>
    
    {/* i want to show all the documents uploaded by candidate and scribe related uploaded documents also but when the user click on print button so this section of uploaded documnets are not be print  */}
    <Box 
    sx={{
      display: isPrinting ? "none" : "block",
      margin: "0px 15px",
      marginTop: 2,
      marginBottom:"40px",
    }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: "bold", mb: 1 }}>
    Uploaded Documents:
  </Typography>

   <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Sr No</b>
              </TableCell>

              <TableCell>
                <b>Document Name</b>
              </TableCell>

              <TableCell align="center">
                <b>Document</b>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {uploadDetails?.length ? (
              uploadDetails.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    {getDocumentName(item?.documenttype)}
                  </TableCell>

                  <TableCell align="center">
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleOpen(item)}
                    >
                      View Document
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No Documents Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

    {/* MODAL */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {getDocumentName(selectedDocument?.documenttype)}

          <IconButton onClick={handleClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            fill="#000000"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            
            <path d="M19 6.41L17.59 5 12 10.59 
                    6.41 5 5 6.41 
                    10.59 12 5 17.59 
                    6.41 19 12 13.41 
                    17.59 19 19 17.59 
                    13.41 12 19 6.41z" />
          </svg>
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {/* IMAGE */}
          {selectedDocument?.fileurl &&
            isImageFile(selectedDocument?.fileurl) && (
              <Box
                component="img"
                src={selectedDocument?.fileurl}
                alt="Document"
                sx={{
                  width: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            )}

          {/* PDF */}
          {selectedDocument?.fileurl &&
            isPdfFile(selectedDocument?.fileurl) && (
              <iframe
                src={selectedDocument?.fileurl}
                title="PDF Document"
                width="100%"
                height="600px"
                style={{
                  border: "none",
                }}
              />
            )}

          {/* Unsupported */}
          {selectedDocument?.fileurl &&
            !isImageFile(selectedDocument?.fileurl) &&
            !isPdfFile(selectedDocument?.fileurl) && (
              <Typography color="error">
                Unsupported File Format
              </Typography>
            )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
